//This Declares Some Key Variables
var _mlp = {
    maxDelegates: 3,
    maxAssociations: 50,
    maxTransactions: 50,
    recaptchaEnabled: false
}
// Set Global vars to use as test cases for event handler attachments.

var userSettingsDialogInitialized = false;

$(document).ready(function () {
    $(document).ajaxComplete(timeout.extendSessionFromAjax);
});

var common = {
    auth: {
        passwordRequirementValidationHelper: function (inputElement, submitButton) {
            var originalPlaceholder;
            $(function () {
                $(submitButton).attr('disabled', 'disabled');
                $('.ui-dialog .outline').removeAttr('disabled');
                $(inputElement).keyup(function () {
                    var pswd = $(this).val();

                    //enable save/submit button if pw meets requirements
                    if (pswd.length >= 8) {
                        $('.list-authentication-helper #pwReqLabel').removeClass('invalid').addClass('valid');
                        $(submitButton).removeAttr('disabled')
                    }
                    else {
                        $('.list-authentication-helper #pwReqLabel').removeClass('valid').addClass('invalid');
                        $(submitButton).attr('disabled', 'disabled')
                        $('.ui-dialog .outline').removeAttr('disabled')
                    }
                    
                    //password strength meter
                    if (pswd.length == 0) {
                        $("#password-strength").removeClass().addClass("password-strength");
                    } else if (pswd.length < 8) {
                        $("#password-strength").removeClass().addClass("password-strength strength-red");
                        if (pswd.length >= 4) {
                            $('#strength-text-container').show();
                            $('#strength-text').text("Too Short").removeClass().addClass("strength-text strength-text-red");
                        }
                    } else if (pswd.length >= 8 && pswd.length < 12) {
                        $("#password-strength").removeClass().addClass("password-strength strength-orange");
                        $('#strength-text-container').show();
                        $('#strength-text').text("Fair").removeClass().addClass("strength-text strength-text-orange");
                    } else if (pswd.length >= 12 && pswd.length < 15) {
                        $("#password-strength").removeClass().addClass("password-strength strength-yellow");
                        $('#strength-text-container').show();
                        $('#strength-text').text("Medium").removeClass().addClass("strength-text strength-text-yellow");
                    } else if (pswd.length >= 15) {
                        $("#password-strength").removeClass().addClass("password-strength strength-green");
                        $('#strength-text-container').show();
                        $('#strength-text').text("Strong").removeClass().addClass("strength-text strength-text-green");
                    }
                });

                $(inputElement).on('focus', function () {
                    originalPlaceholder = $(this).attr('placeholder') || '';
                    $(this).attr('placeholder', 'At least 8 characters');
                });

                $(inputElement).on('blur', function () {
                    $(this).attr('placeholder', originalPlaceholder);
                    var pswd = $(this).val();
                    if (pswd.length < 4) {
                        $('#strength-text-container').show();
                        $('#strength-text').text("Too Short").removeClass().addClass("strength-text strength-text-red");
                    }
                });
            });
        },
        validation: function (confirmAuthenticationUrl) {
            //SignUp
            $('#authentication-signup input').tooltipster({
                trigger: 'custom',
                onlyOne: false,
                position: 'left'
            });

            common.auth.passwordRequirementValidationHelper("input#sign-up-password", ".btn-signup")
            
            $.validator.addMethod("atLeastEightCharacters", function (value, element) {
                return this.optional(element) || value.length >= 8;
            }, "");

            $("#authentication-signup").validate({
                onkeyup: function (element) {
                    $(element).valid();
                },
                errorPlacement: function (error, element) {

                    var lastError = $(element).data('lastError'),
                        newError = $(error).text();

                    $(element).data('lastError', newError);

                    if (newError !== '' && newError !== lastError) {
                        $(element).tooltipster('content', newError);
                        $(element).tooltipster('show');
                    }
                },
                success: function (label, element) {
                    $(element).tooltipster('hide');
                },
                rules: {
                    password: {
                        atLeastEightCharacters: true
                    },
                    confirm_password: {
                        required: true,
                        equalTo: "#sign-up-password"
                    },
                    email: {
                        required: true,
                        email: true
                    }
                },
                messages: {
                    password: {
                        required: "Password can not be empty",
                        minlength: "Your password must be at least 8 characters long",
                    },
                    confirm_password: {
                        required: "Please provide a password",
                        equalTo: "Please enter the same password as above"
                    },
                    email: {
                        required: "Email address can not be empty",
                        email: "Please enter a valid email address e.g. abc@company.com"
                    }
                }
            });

            $("#authentication-signup #sign-up-email").change(function () {
                CheckIfFederatedAndSignUp();
            });

            $("#authentication-signin #sign-in-email").change(function () {
                CheckIfFederatedAndSignIn();
            });

            common.auth.isValidEmail = function (email) {
                const emailPattern = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;
                return emailPattern.test(email);
            };

            async function isFederatedEmail(email) {
                // Validate email format
                if (!common.auth.isValidEmail(email)) {
                    return false;
                }
                else {
                    try {
                        var nameArray = $("#authentication-signin").attr('name').split(",");
                        const emailDomain = email.split('@').pop();
                        var token = $('input[name="__RequestVerificationToken"]').val();

                        const result = await $.ajax({
                            type: "POST",
                            url: nameArray[2],
                            data: { emailDomain: emailDomain, __RequestVerificationToken: token },
                            dataType: "json"
                        });

                        if (typeof result !== 'object') {
                            throw new Error('Response is not JSON');
                        }

                        return result.Result;
                    } catch (error) {
                        return false;
                    }
                }
            }

            function CheckIfFederatedAndSignIn() {
                var email = $("#authentication-signin #sign-in-email").val();

                isFederatedEmail(email).then(isFederated => {
                    if (isFederated) {
                        clearValidationErrorsSignIn();
                        $("#authentication-signin div.sign-in-password").hide();
                        $("#authentication-signin div.sign-in-buttons").hide();
                        $("#authentication-signin div.redirect-banner").show();
                        $("#authentication-signin :input").prop("disabled", true); // Disable the form elements
                        $("#authentication-signin").submit(function (event) {
                            event.preventDefault(); // Prevent form submission
                        });
                        setTimeout(() => SendToFederation(email), 2000);
                    }
                });
            }

            function CheckIfFederatedAndSignUp() {
                var email = $("#authentication-signup #sign-up-email").val();

                isFederatedEmail(email).then(isFederated => {
                    if (isFederated) {
                        $("#authentication-signup div.sign-up-password").hide();
                        $("#authentication-signup div.redirect-banner").show();
                        $("#authentication-signup :input").prop("disabled", true); // Disable the form elements
                        $("#authentication-signup").submit(function (event) {
                            event.preventDefault(); // Prevent form submission
                        });
                        setTimeout(() => SendToFederation(email), 2000);
                    }
                });
            }

            function SendToFederation(email) {
                function federationSubmit() {
                    $("#externalLoginForm #externalBrowserFingerprint").val($("input[name='BrowserFingerprint']").val());
                    $("#externalLoginForm #externalUserName").val(email);

                    $("#externalLoginForm").submit();
                }

                federationSubmit();
            }

            function IsValidLogin() {
                var email = $("#sign-in-email").val();
                if (!common.auth.isValidEmail(email)) {
                    displayErrors("<i class='fa fa-times'></i>Please enter a valid email address.");
                    return false;
                }

                var pw = $("#sign-in-password").val();
                if (!pw || pw.trim() === "") {
                    displayErrors("<i class='fa fa-times'></i>Password is required.");
                    return false;
                }

                return true;
            }

            //AJAX for login, email/PW validation and recaptcha if user is on 4th or 5th attempt of loggin in
            function signInSubmit(recaptchaResponse) {
                if (common.auth.cookiesEnabled()) {
                    CheckIfFederatedAndSignIn();
                    if (!IsValidLogin()) {
                        common.ui.init.resetRecaptcha();
                        $('#sign-in-password').val('');
                        return;
                    }
                    $.ajax({
                        cache: false,
                        url: confirmAuthenticationUrl,
                        dataType: "json",
                        success: function (returnedData) {
                            if (!returnedData) {
                                var nameArray = $("#authentication-signin").attr('name').split(",");
                                var LoginURL = nameArray[0];
                                var mfaUrl = nameArray[1];
                                var token = $('input[name="__RequestVerificationToken"]').val();
                                var data = $('#authentication-signin').serialize();
                                if (_mlp.recaptchaEnabled) {
                                    data += '&g-recaptcha-response=' + grecaptcha.getResponse();
                                }
                                data.__RequestVerificationToken = token;

                                //if recaptcha is empty, return false
                                if (_mlp.recaptchaEnabled === "True" && $('#g-recaptcha-response').val() === "") {
                                    $('#sign-in-password').val('').focus();
                                    displayErrors("<i class='fa fa-times'></i> reCAPTCHA input is required.");
                                    return;
                                }
                                $.ajax({
                                    type: "POST",
                                    url: LoginURL,
                                    cache: false,
                                    data: data
                                }).done(function (loginResult) {
                                    common.ui.init.resetRecaptcha();
                                    clearValidationErrorsSignIn();
                                    if (loginResult) {
                                        if (loginResult === 'MFA') {
                                            $('#sign-in-email').val('');
                                            $('#sign-in-password').val('');
                                            $confirm = $('<div>', { "data-action-url": mfaUrl, "data-display-width": 365, "data-action-type": "modal", "data-title": "Verify Device" });
                                            common.ui.dialog($confirm);
                                            return false;
                                        }
                                        else {
                                            $('#sign-in-password').val('').focus();
                                            for (var i = 0; i < loginResult.length; i++) {
                                                if (loginResult[i].indexOf('Email') >= 0) {
                                                    addError('#sign-in-email-error', loginResult[i]);
                                                }
                                                else if (loginResult[i].indexOf('Password') >= 0) {
                                                    addError('#sign-in-password-error', loginResult[i]);
                                                }
                                                else if (loginResult[i].indexOf('Attempts') >= 0) {
                                                    continue;
                                                }
                                                else if (loginResult[i].indexOf('Invalid') >= 0) {
                                                    if (loginResult[i + 1] !== -2 && loginResult[i + 1] <= 2) { //user exists, on last two attempts. Display reCAPTCHA
                                                        displayCredentialErrors(loginResult[i + 1] + " attempt(s) remaining.<br />");
                                                        return false;
                                                    } else {
                                                        displayCredentialErrors("");
                                                        return false;
                                                    }
                                                }
                                                else if (loginResult[i].indexOf('RequiresVerification') >= 0) {
                                                    alert("Requires Verification. Please contact the call center for assistance.");
                                                    return false;
                                                }
                                                else if (loginResult[i].indexOf('reCAPTCHA') >= 0) {
                                                    displayErrors("<fa class='fa fa-times'></fa>" + loginResult[i]);
                                                }
                                                else {
                                                    if (loginResult[i] === null || loginResult[i].match(/^\s*$/) !== null) {
                                                        location.reload();
                                                    } else {
                                                        displayErrors("<i class='fa fa-times'></i>" + loginResult[i]);
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        return false;
                                    } else {
                                        common.ui.init.resetRecaptcha();
                                        location.reload();
                                    }
                                }).fail(function () {
                                    displayErrors("<i class='fa fa-times'></i>There was an issue completing the sign in request. Please try again later.");
                                    common.ui.init.resetRecaptcha();
                                    $('#sign-in-password').val('');
                                });
                            }
                            else {
                                common.ui.init.resetRecaptcha();
                                location.reload();
                            }
                        },
                        error: function () {
                            displayErrors("<i class='fa fa-times'></i>There was an issue completing the sign in request. Please try again later.");
                            common.ui.init.resetRecaptcha();
                            $('#sign-in-password').val('');
                        }
                    });
                }
                else {
                    displayErrors("<i class='fa fa-times'></i> Cookies are required for some access. Enable cookies in your browser settings and retry.");
                }
            }

            //Init Sign In Recaptcha
            common.ui.init.ajaxLoginRecaptcha('#authentication-signin', signInSubmit);

            //AJAX for register, email/PW/PW confirmation validation
            function signup() {
                if (common.auth.cookiesEnabled()) {
                    CheckIfFederatedAndSignUp();
                    $.ajax({
                        cache: false,
                        url: confirmAuthenticationUrl,
                        dataType: "json",
                        success: function (returnedData) {
                            if (!returnedData) {
                                var RegisterURL = $("#authentication-signup").attr('name');
                                var token = $('input[name="__RequestVerificationToken"]').val();
                                var data = $('#authentication-signup').serialize();
                                if (_mlp.recaptchaEnabled) {
                                    data += '&g-recaptcha-response=' + grecaptcha.getResponse();
                                }
                                data.__RequestVerificationToken = token;

                                $.ajax({
                                    type: "POST",
                                    url: RegisterURL,
                                    cache: false,
                                    data: data
                                }).done(function (errorMessages) {
                                    common.ui.init.resetRecaptcha();
                                    clearValidationErrorsSignUp();

                                    if (errorMessages !== undefined &&
                                        errorMessages.isFederatedRegistration !== undefined &&
                                        errorMessages.isFederatedRegistration === true) {
                                        federatedRegistration();
                                    }

                                    if (errorMessages) {
                                        for (var key in errorMessages) {
                                            // Email field error
                                            if (key == 2) {
                                                addError('#sign-up-email-error', errorMessages[key]);
                                            }
                                            // Password field error
                                            if (key == 3) {
                                                $("#sign-up-password").val('');
                                                addError('#sign-up-password-error', errorMessages[key]);
                                            }
                                            // Confirmation password field error
                                            if (key == 4) {
                                                $("#sign-up-password").val('');
                                                addError('#sign-up-confirm-password-error', errorMessages[key]);
                                            }
                                            // Pwned PW warning
                                            if (key == 5) {
                                                displayRegistrationWarnings("<i class='fa fa-exclamation-triangle'></i> " + errorMessages[key]);
                                            }
                                            // Pwned PW error
                                            if (key == 6) {
                                                displayRegistrationErrors("<i class='fa fa-times'></i> " + errorMessages[key]);
                                            }
                                            // Success
                                            if (key == 1) {
                                                $('.list-authentication-helper #pwReqLabel').removeClass('invalid').removeClass('valid');
                                                displaySignUpMessage("<i class='fa fa-check'></i> Thanks! An email has been sent with next steps.");
                                            }
                                            $("#sign-up-email").val('');
                                            $("#sign-up-password").val('');
                                            $("#signup-confirm-password").val('');
                                            $("#password-strength").removeClass().addClass("password-strength");
                                            $('#strength-text-container').hide();
                                            $('#strength-text').text("").removeClass().addClass("strength-text");
                                        }
                                        return false;
                                    } else {
                                        location.reload();
                                        common.ui.init.resetRecaptcha();
                                    }
                                }).fail(function () {
                                    common.ui.init.resetRecaptcha();
                                });
                            }
                            else {
                                location.reload();
                                common.ui.init.resetRecaptcha();
                            }
                        }
                    });
                }
                else {
                    displayRegistrationErrors("<i class='fa fa-times'></i> Cookies are required for some access. Enable cookies in your browser settings and retry.");
                }
            }

            //Init Register Recaptcha
            common.ui.init.ajaxLoginRecaptcha('#authentication-signup', signup);

            //add error message and class
            function addError(ID, errorMessage) {
                $(ID + "-field").html(errorMessage);
                $(ID).parent().addClass("input-error");
            }
            //display validation errors
            function displayErrors(errorHTML) {
                $("#sign-in-error-message-row").show();
                $('#sign-in-error-message').html(errorHTML);
            }
            //Display failed login credential errors
            function displayCredentialErrors(errorHTML) {
                $("#credential-error-message-row").show();
                $('#credential-error-message').html(errorHTML);
            }

            //display sign up validation errors
            function displaySignUpMessage(html) {
                $("#sign-up-message-row").show();
                $('#sign-up-message').html(html);

                adjustArticleAuthHeight("#sign-up-message-row", true);
            }

            //clear all validation errors on email, password
            function clearValidationErrorsSignIn() {
                var starting = '#sign-in';
                var endingArray = ['-email-error', '-password-error'];

                for (var i = 0; i < endingArray.length; i++) {
                    $(starting + endingArray[i] + "-field").html("");
                    $(starting + endingArray[i]).parent().removeClass("input-error");
                }
                $("#sign-in-error-message-row").hide();
                $('#sign-in-error-message').html("");
            }

            //display validation warnings
            function displayRegistrationWarnings(errorHTML) {
                $("#sign-up-error-message-row").show();
                $("#sign-up-error-message").hide();
                $('#sign-up-warning-message').html(errorHTML);

                adjustArticleAuthHeight("#sign-up-error-message-row", true);
            }

            //display validation errors
            function displayRegistrationErrors(errorHTML) {
                $("#sign-up-error-message-row").show();
                $("#sign-up-warning-message").hide();
                $('#sign-up-error-message').html(errorHTML);

                adjustArticleAuthHeight("#sign-up-error-message-row", true);
            }
            //clear all validation errors on email, password, password confirm
            function clearValidationErrorsSignUp() {
                var starting = '#sign-up';
                var endingArray = ['-email-error', '-password-error', '-confirm-password-error'];

                for (var i = 0; i < endingArray.length; i++) {
                    $(starting + endingArray[i] + "-field").html("");
                    $(starting + endingArray[i]).parent().removeClass("input-error");
                }

                if ($('#sign-up-error-message-row').is(':visible')) {
                    adjustArticleAuthHeight("#sign-up-error-message-row", false);
                }

                $("#sign-up-error-message-row").hide();
                $('#sign-up-error-message').html("");
                $("#sign-up-message-row").hide();
                $('#sign-up-message').html("");
            }

            // SignUp container height adjustment
            function adjustArticleAuthHeight(innerSelector, add) {
                if ($("#article-authentication.authentication-client").is(":visible")) {
                    var messageBoxHeight = parseInt($(innerSelector).css('height'), 10);
                    var signUpContainerHeight = parseInt($('#article-authentication').css('height'), 10);
                    if (add) {
                        $('#article-authentication').css('height', signUpContainerHeight + messageBoxHeight + 10);
                    }
                    else {
                        $('#article-authentication').css('height', signUpContainerHeight - messageBoxHeight - 10);
                    }
                }
            }

            function federatedRegistration() {

                $("#externalLoginForm #externalBrowserFingerprint").val($("input[name='BrowserFingerprint']").val());
                $("#externalLoginForm #isFederatedRegistration").val(true);
                $("#externalLoginForm #externalUserName").val($("#authentication-signup #sign-up-email").val());

                $("#externalLoginForm").submit();
            }

            //SignIn
            $('#authentication-signin input').tooltipster({
                trigger: 'custom',
                onlyOne: false,
                position: 'left'
            });
            $("#authentication-signin").validate({
                onkeyup: function (element) {
                    $(element).valid();
                },
                errorPlacement: function (error, element) {

                    var lastError = $(element).data('lastError'),
                        newError = $(error).text();

                    $(element).data('lastError', newError);

                    if (newError !== '' && newError !== lastError) {
                        $(element).tooltipster('content', newError);
                        $(element).tooltipster('show');
                    }
                },
                success: function (label, element) {
                    $(element).tooltipster('hide');
                },
                rules: {
                    password: {
                        required: true
                    },
                    email: {
                        required: true,
                        email: true
                    }
                },
                messages: {
                    password: {
                        required: "Password can not be empty"
                    },
                    email: {
                        required: "Email address can not be empty",
                        email: "Please enter a valid email address e.g. abc@company.com"
                    }
                }
            });
        },
        interactionClient: function () {
            $('#user-auth-selection a').click(function (e) {
                var $e = $(this),
                    $id = $e.data("id"),
                    $authEnabled,
                    $authDisabled;

                if ($id === "signin") {
                    $authEnabled = $('form#authentication-signin input');
                    $authDisabled = $('form#authentication-signup input');
                } else {
                    $authEnabled = $('form#authentication-signup input');
                    $authDisabled = $('form#authentication-signin input');
                }
                $("#article-authentication.authentication-client").show(0, function () {
                    $("form#authentication-" + $id + "").addClass('form-active').show(0, function () {
                        $authEnabled.tooltipster('show');
                        $authEnabled.tooltipster('reposition');
                        $authDisabled.tooltipster('hide');
                        $('form#authentication-' + $id + '').find("input[type='email']").focus();
                    });
                    $("form[id!='authentication-" + $id + "']").removeClass('form-active').hide();
                    //Update Tabs
                    $("#user-auth-selection a[data-id='" + $id + "']").removeAttr("outline");
                    $("#user-auth-selection a[data-id!='" + $id + "']").attr("outline", "");
                });

                e.preventDefault();
            });
            $("#user-auth-selection a[data-id='signin']").click();
        },
        interaction: function () {
            $('#user-auth-selection a').click(function (e) {
                var $e = $(this),
                    $id = $e.data("id"),
                    $authEnabled,
                    $authDisabled;

                if ($id === "signin") {
                    $authEnabled = $('form#authentication-signin input');
                    $authDisabled = $('form#authentication-signup input');
                } else {
                    $authEnabled = $('form#authentication-signup input');
                    $authDisabled = $('form#authentication-signin input');
                }

                $("#article-authentication.authentication-pwc").addClass("authentication-active").slideDown(500, function () {
                    $("form#authentication-" + $id + "").addClass('form-active').slideDown(500, function () {
                        $authEnabled.tooltipster('show');
                        $authEnabled.tooltipster('reposition');
                        $authDisabled.tooltipster('hide');
                        $('form#authentication-' + $id + '').find("input[type='email']").focus();
                    });
                    $("form[id!='authentication-" + $id + "']").removeClass('form-active').slideUp();
                    //Update Tabs
                    $("#user-auth-selection a[data-id='" + $id + "']").removeAttr("outline");
                    $("#user-auth-selection a[data-id!='" + $id + "']").attr("outline", "");
                });

                $("#article-authentication.authentication-client").show(0, function () {
                    $("form#authentication-" + $id + "").addClass('form-active').show(0, function () {
                        $authEnabled.tooltipster('show');
                        $authEnabled.tooltipster('reposition');
                        $authDisabled.tooltipster('hide');
                    });
                    $("form[id!='authentication-" + $id + "']").removeClass('form-active').hide();
                    //Update Tabs
                    $("#user-auth-selection a[data-id='" + $id + "']").removeAttr("outline");
                    $("#user-auth-selection a[data-id!='" + $id + "']").attr("outline", "");
                });

                e.preventDefault();
            });

            $('html').click(function (e) {
                resetAuth();
            });

            $('a.btn-auth-destroy').click(function (e) {
                resetAuth();
                e.preventDefault();
            });

            $('#article-authentication').click(function (e) {
                e.stopPropagation();
            });

            function resetAuth() {
                $('#article-authentication.authentication-pwc form#authentication-signin input').tooltipster('hide');
                $('#article-authentication.authentication-pwc form#authentication-signup input').tooltipster('hide');
                $('#article-authentication.authentication-pwc form.form-active').slideUp(500, function () {
                    $("#article-authentication.authentication-pwc #user-auth-selection a[data-id='signin']").attr("outline", "");
                    $("#article-authentication.authentication-pwc #user-auth-selection a[data-id='signup']").removeAttr("outline");
                    $('#article-authentication.authentication-pwc').removeClass('authentication-active');
                });
            }
        },
        cookiesEnabled: function () {
            return "cookie" in document && (document.cookie.length > 0 ||
                (document.cookie = "test").indexOf.call(document.cookie, "test") > -1);
        },
        browserFingerprint: function () {
            var browserFingerprintInputs = $("input[name='BrowserFingerprint']");

            var options = {
                excludeFlashFonts: true,
                excludePixelRatio: true,
                excludeAdBlock: true,
                excludeWebGL: true,
                excludeAvailableScreenResolution: true,
                excludeScreenResolution: true,
                excludeTimezoneOffset: true,
                excludeTouchSupport: true,
                excludeIEPlugins: true,
                excludePlugins: true,
                excludeHasLiedBrowser: true,
                excludeHasLiedOs: true,
                excludeHasLiedResolution: true,
                excludeHasLiedLanguages: true,
                excludeOpenDatabase: true,
                excludeAddBehavior: true,
                excludeIndexedDB: true,
                excludeSessionStorage: true,
                excludeColorDepth: true,
                excludeLanguage: true,
                excludeCanvas: true
            };

            new Fingerprint2(options).get(function (result, components) {
                $(browserFingerprintInputs).each(function () {
                    if ($(this).val().length === 0) {
                        $(this).val(result);
                    }
                });
            });
        }
    },
    ui: {
        helper: {
            userSettings: {
                hasReset: false
            },
            updateClonedMultipleTransaction: function (parent) {
                var $parent = $(parent),
                    $rows = $parent.find('tr');

                $rows.each(function (i, e) {
                    var $row = $(e);

                    $row.find("[id*='AccountInformationID']").attr('name', "TransactionViewModel[" + i + "].AccountInformationID").attr('id', "TransactionViewModel[" + i + "].AccountInformationID");
                    $row.find("[id*='TransactionID']").attr('name', "TransactionViewModel[" + i + "].TransactionID").attr('id', "TransactionViewModel[" + i + "].TransactionID");
                    $row.find("[id*='TransactionDescription']").attr('name', "TransactionViewModel[" + i + "].TransactionDescription").attr('id', "TransactionViewModel[" + i + "].TransactionDescription");
                    $row.find("[for*='TransactionDescription']").attr('for', "TransactionViewModel[" + i + "].TransactionDescription");
                    $row.find("[id*='TransactionDate']").attr('name', "TransactionViewModel[" + i + "].TransactionDate").attr('id', "TransactionViewModel[" + i + "].TransactionDate");
                    $row.find("[data-valmsg-for*='TransactionDate']").attr('data-valmsg-for', "TransactionViewModel[" + i + "].TransactionDate");

                    $row.find("[id*='TransactionAmount']").attr('name', "TransactionViewModel[" + i + "].TransactionAmount").attr('id', "TransactionViewModel[" + i + "].TransactionAmount");
                    $row.find("[data-valmsg-for*='TransactionAmount']").attr('data-valmsg-for', "TransactionViewModel[" + i + "].TransactionAmount");
                    $row.find("[id*='TransactionAmount']").closest('td').attr('id', 'ownershipInformationTransactionAmount');

                    $row.find("[id*='Units']").attr('name', "TransactionViewModel[" + i + "].Units").attr('id', "TransactionViewModel[" + i + "].Units");
                    $row.find("[data-valmsg-for*='Units']").attr('data-valmsg-for', "TransactionViewModel[" + i + "].Units");
                    $row.find("[id*='Units']").closest('td').attr('id', 'ownershipInformationTransactionUnits');
                });
            },
            updateClonedAccess: function (parent) {
                var $parent = $(parent),
                    $rows = $parent.find('tr');
                var count = 0;
                var maximumAccessCount = 3;
                $rows.each(function (i, e) {
                    var $row = $(e);
                    $row.find("[id*='IsReactiveControl']").attr('name', "K1AssignedAccess[" + i + "].IsReactiveControl").attr('id', "K1AssignedAccess[" + i + "].IsReactiveControl");
                    $row.find("[id*='TPSAccessControlTypeID']").attr('name', "K1AssignedAccess[" + i + "].TPSAccessControlTypeID").attr('id', "K1AssignedAccess[" + i + "].TPSAccessControlTypeID");
                    $row.find("[id*='HasFullAccess']").attr('name', "K1AssignedAccess[" + i + "].HasFullAccess").attr('id', "K1AssignedAccess[" + i + "].HasFullAccess");
                    $row.find("[id*='Email']").attr('name', "K1AssignedAccess[" + i + "].Email").attr('id', "K1AssignedAccess[" + i + "].Email");
                    $row.find("[id*='AssignedApprovedBy']").attr('name', "K1AssignedAccess[" + i + "].AssignedApprovedBy").attr('id', "K1AssignedAccess[" + i + "].AssignedApprovedBy");
                    $row.find("[id*='K1AccessID']").attr('name', "K1AssignedAccess[" + i + "].K1AccessID").attr('id', "K1AssignedAccess[" + i + "].K1AccessID");

                    $row.find("[id*='principalSelection']").attr('id', "principalSelection_" + i);
                    $row.find("[id*='limitedSelection']").attr('id', "limitedSelection_" + i);

                    if ($row.find("[id*='AssignedApprovedBy']").val().toUpperCase() === $("#AciveUserEmail").val().toUpperCase()) {
                        count++;
                    }
                });

                if (count < maximumAccessCount) {
                    $(".btn-save-access-records").show();
                } else {
                    $(".btn-save-access-records").hide();
                }
            },
            showHideToggle: function (showEle, hideEle) {
                //Needs more work
                $(showEle).show();
                $(hideEle).hide();
            },
            initUserSettings: function (premiumID) {
                var init = function () {
                    var _cxp = {
                        btnType: ".box-type a",
                        btnConfirm: ".confirm-user-type-btn",
                        btnNext: ".btn-manage-next",
                        btnPrev: ".btn-manage-prev",
                        chkConfirm: ".confirm-user-type-switch input#confirmUserType",
                        errConfirm: ".box-type-row-confirm-error",
                        selectCountry: "#CountryID",
                        inputState: ".textbox-statecode",
                        inputZip: ".textbox-zipcode",
                        cssClass: {
                            active: "cxp-active"
                        },
                        val: {
                            groupName: null,
                            groupType: null,
                            groupObj: null,
                            disclaimer: null,
                            groupDisclaimer: null,
                            confirmed: false,
                            countryCodeUS: "null"
                        }
                    };
                    var cxp = {
                        reset: function (obj) {
                            $(".box-type-user-select").fadeTo(250, 1).slideDown();
                            $(".box-type").removeClass(_cxp.cssClass.active);
                            $(".box-type-user-confirm").slideUp();
                            $("[data-group-type-container]").hide();
                            $(".confirm-header").removeClass(_cxp.cssClass.active);
                            $(".confirm-header .confirm-header-wrapper").find("div, span, i").remove();
                            _cxp.val.confirmed = $(_cxp.chkConfirm).prop("checked", "");
                            common.ui.helper.userSettings.hasReset = true;
                        },
                        build: function (obj) {
                            $(".box-type").removeClass(_cxp.cssClass.active);
                            $(obj).parents('.box-type').addClass(_cxp.cssClass.active);

                            _cxp.val.confirmed = $(_cxp.chkConfirm).prop("checked", "");

                            var newDisclaimerText = _cxp.val.disclaimer;
                            if (_cxp.val.groupDisclaimer) {
                                newDisclaimerText += "<span class='label-group-disclaimer'>" + _cxp.val.groupDisclaimer + "</span>";
                            }

                            if (($("#ManageViewFlag").val() && common.ui.helper.userSettings.hasReset) || (!$("#ManageViewFlag").val())) {
                                $(".box-type-user-confirm .confirm-user-type-label").html(newDisclaimerText);
                                $(".box-type-user-confirm").slideDown().find("label.confirm-user-type-label").fadeOut(0).fadeIn(150);
                            }
                        },
                        select: function (obj, setDefault) {
                            if (_cxp.val.confirmed === true) {
                                $objHeader = $(obj).closest("form").find(".confirm-header");
                                $objIconGroup = $(obj).closest(".box-type-row").find(".box-type-icon-group").clone();
                                var currDxAnimation = 250;
                                if (setDefault === true) {
                                    currDxAnimation = 0;
                                }

                                if ($("#ManageViewFlag").val()) {
                                    if ($("#LookupTPSUserTypeID").val() > 1) {
                                        if ($(".confirm-header .fa-cog").length === 0) {
                                            $(".confirm-header").addClass(_cxp.cssClass.active).find(".confirm-header-wrapper").prepend($(".box-type-icon-group.group-other").clone()).append("<span>" + _cxp.val.groupName + "</span>").hide().slideDown().append('<i class="fa fa-cog"></i>').fadeIn();
                                        }
                                    } else {
                                        if ($(".confirm-header .fa-cog").length === 0) {
                                            $(".confirm-header").addClass(_cxp.cssClass.active).find(".confirm-header-wrapper").prepend($(".box-type-icon-group.group-owner").clone()).append("<span>" + _cxp.val.groupName + "</span>").hide().slideDown().append('<i class="fa fa-cog"></i>').fadeIn();
                                        }
                                    }
                                } else {
                                    $objHeader.addClass(_cxp.cssClass.active).find(".confirm-header-wrapper").prepend($objIconGroup).append("<span>" + _cxp.val.groupName + "</span>").hide().slideDown().append('<i class="fa fa-cog"></i>').fadeIn();
                                }

                                $(".box-type-user-select").fadeTo(currDxAnimation, 0, "linear", function () {
                                    $(".box-type-user-select").fadeTo(currDxAnimation, 0, "linear", function () {
                                        $(".box-type-user-confirm").slideUp(currDxAnimation);
                                        $(".box-type-user-select").slideUp(currDxAnimation, function () {
                                            $("[data-group-type-container='" + _cxp.val.groupType + "']").slideDown(currDxAnimation, function () {
                                                if (_cxp.val.groupType === 1) {
                                                    $("[data-group-type-container='0'] :input").attr("disabled", true);
                                                    $("[data-group-type-container='1'] :input").attr("disabled", false);
                                                }
                                                else {
                                                    $("[data-group-type-container='0'] :input").attr("disabled", false);
                                                    $("[data-group-type-container='1'] :input").attr("disabled", true);
                                                }
                                                $("#VerifiedSSN").attr("disabled", true);
                                                $("#VerifiedPaperless").attr("disabled", true);
                                                $(".ux-dialog").dialog({ position: { my: "center", at: "center", of: window } });

                                            });
                                        });
                                    });
                                });
                            } else {
                                $(_cxp.errConfirm).slideDown();
                            }
                        },
                        init: function () {
                            function toggleStateZipVisibility(type) {
                                $(_cxp.inputState).css('visibility', type);
                                $(_cxp.inputZip).css('visibility', type);
                                if ($('.united-states-only').length > 0) {
                                    if (type == 'hidden') {
                                        $('.united-states-only').hide();
                                    } else {
                                        $('.united-states-only').show();
                                    }
                                }
                            }

                            var currCountryCode = $(_cxp.selectCountry).find(":selected").val();
                            if (currCountryCode === _cxp.val.countryCodeUS) {
                                toggleStateZipVisibility('visible');
                            } else {
                                toggleStateZipVisibility('hidden');
                            }

                            $('.ux-dialog').on('click', _cxp.btnType, function (e) {
                                _cxp.val.disclaimer = $(this).data("type-disclaimer");
                                _cxp.val.groupDisclaimer = $(this).closest('div.box-type-group').data('group-disclaimer');
                                _cxp.val.groupType = $(this).closest(".box-type-row").data("group-type");
                                _cxp.val.groupName = $(this).text();
                                _cxp.val.groupObj = $(this);
                                var originalTPSUserTypeID = $("#OriginalLookupTPSUserTypeID").val();
                                $("#LookupTPSUserTypeID").val($(this).data("user-type-id"));
                                if ($("#ManageViewFlag").val() && $(this).data("user-type-id") === 1 || originalTPSUserTypeID > 1 && !common.ui.helper.userSettings.hasReset) {
                                    _cxp.val.confirmed = true;
                                    cxp.select(_cxp.val.groupObj, true);
                                } else {
                                    cxp.build(this);
                                }

                                e.preventDefault();
                            });

                            $('.ux-dialog').on('change', _cxp.chkConfirm, function (e) {
                                _cxp.val.confirmed = $(this).prop("checked");
                                if (_cxp.val.confirmed === true) {
                                    $(_cxp.errConfirm).slideUp();
                                }
                                else {
                                    $(_cxp.errConfirm).slideDown();
                                }
                                e.preventDefault();
                            });

                            $('.ux-dialog').on('click', _cxp.btnConfirm, function (e) {
                                if ($('.ux-dialog').find('.box-type-user-select').css('display') === 'block') {
                                    cxp.select(_cxp.val.groupObj);
                                }
                                e.preventDefault();
                            });

                            $('.ux-dialog').on('click', "." + _cxp.cssClass.active, function (e) {
                                if ($("#ManageViewFlag").val()) {
                                    $(".box-type-group").addClass("disabled-button");
                                    cxp.reset();
                                    e.preventDefault();
                                    $(".box-type-group").removeClass("disabled-button");
                                }
                            });

                            $('.ux-dialog').on('click', ".manage-save", function (e) {
                                if ($("#ManageViewFlag").val()) {
                                    common.ui.helper.userSettings.hasReset = false;
                                    _cxp.val.confirmed = true;
                                }
                            });

                            $('.ux-dialog').on('change', _cxp.selectCountry, function (e) {
                                if ($(this).find(":selected").val() === _cxp.val.countryCodeUS) {
                                    toggleStateZipVisibility('visible');
                                } else {
                                    toggleStateZipVisibility('hidden');

                                }

                                e.preventDefault();
                            });
                 
                            // Set userSettingsDialogInitialized to True to avoid further event handlers to be propagated.
                            userSettingsDialogInitialized = true;

                            if ($("#OriginalLookupTPSUserTypeID").val() === premiumID) {
                                _cxp.val.confirmed = true;
                            }
                        }
                    };
                    cxp.init();

                    //Activate Terms and Conditions
                    $('.ux-dialog').on('click', ".ux-action.action-tandc", function () {
                        $("#confirm-modal").parent().removeClass("auto-height-modal");
                        $("#confirm-modal").parent().addClass("fixed-height-modal");
                        $("#confirm-modal").parent().parent().css("top", "200px");
                        $(".ui-dialog-title").html("Terms of use");
                        common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-tandc'), $('.ux-dialog .content-confirm-form'));
                        $(".ux-dialog").dialog({ width: 1000, height: 450, position: { my: "center", at: "center", of: window } });
                        $(".ui-dialog-titlebar-close").show();
                        $(".ui-dialog").on('click', ".ui-dialog-titlebar-close", function () {
                            if($("#ActiveSection").val() != null){
                                $(".ui-dialog-title").html("User Activation");
                            }
                            $("#confirm-modal").parent().addClass("auto-height-modal");
                            $("#confirm-modal").parent().removeClass("fixed-height-modal");
                            common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-form'), $('.ux-dialog .content-confirm-tandc'));
                            $(".ux-dialog").dialog({ width: 1000, height: "auto", position: { my: "center", at: "center", of: window } });
                            $(".ui-dialog-titlebar-close").hide();
                            $('.ui-dialog .ui-dialog-buttonpane').show();
                        });
                        $('.ui-dialog .ui-dialog-buttonpane').hide();
                    });
                    $('.ux-dialog').on('click', ".ux-action.action-tandc-close", function () {
                        if ($("#ActiveSection").val() != null) {
                            $(".ui-dialog-title").html("User Activation");
                        }
                        $("#confirm-modal").parent().addClass("auto-height-modal");
                        common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-form'), $('.ux-dialog .content-confirm-tandc'));
                        $(".ux-dialog").dialog({ width: 1000, height: "auto", position: { my: "center", at: "center", of: window } });
                        $(".ui-dialog-titlebar-close").hide();
                        $("#confirm-modal").parent().removeClass("fixed-height-modal");
                        $('.ui-dialog .ui-dialog-buttonpane').show();
                    });
                    $('.ux-dialog').on('click', ".ux-action.action-tandc-send-email", function () {
                        $('#action-tandc-send-email-link').submit();
                        $('#action-tandc-send-email-link').text("Sending...");
                        setTimeout(function () {
                            $('#action-tandc-send-email-link').text("E-mail sent ✔");
                            $('#action-tandc-send-email-link').removeAttr("href");
                            $('#action-tandc-send-email-link').prop("disabled", true);
                        }, 2000);
                    });

                    $('.ux-dialog').on('click', ".ux-action.action-privacy", function () {
                        $("#confirm-modal").parent().removeClass("auto-height-modal");
                        $("#confirm-modal").parent().addClass("fixed-height-modal");
                        $("#confirm-modal").parent().parent().css("top", "200px !important");
                        $(".ui-dialog-title").html("Privacy Policy");
                        common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-privacy'), $('.ux-dialog .content-confirm-form'));
                        $(".ux-dialog").dialog({ width: 1000, height: 450, position: { my: "center", at: "center", of: window } });
                        $(".ui-dialog-titlebar-close").show();
                        $(".ui-dialog").on('click', ".ui-dialog-titlebar-close", function () {
                            $("#confirm-modal").parent().addClass("auto-height-modal");
                        $("#confirm-modal").parent().removeClass("fixed-height-modal");
                            if ($("#ActiveSection").val() != null) {
                                $(".ui-dialog-title").html("User Activation");
                            }
                            common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-form'), $('.ux-dialog .content-confirm-privacy'));
                            $(".ux-dialog").dialog({ width: 1000, height: "auto", position: { my: "center", at: "center", of: window } });
                            $(".ui-dialog-titlebar-close").hide();
                            $('.ui-dialog .ui-dialog-buttonpane').show();
                        });
                        $('.ui-dialog .ui-dialog-buttonpane').hide();
                    });
                    $('.ux-dialog').on('click', ".ux-action.action-privacy-close", function () {
                        if ($("#ActiveSection").val() != null) {
                            $(".ui-dialog-title").html("User Activation");
                        }
                        $("#confirm-modal").parent().addClass("auto-height-modal");
                        $("#confirm-modal").parent().removeClass("fixed-height-modal");
                        common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-form'), $('.ux-dialog .content-confirm-privacy'));
                        $(".ux-dialog").dialog({ width: 1000, height: "auto", position: { my: "center", at: "center", of: window } });
                        $(".ui-dialog-titlebar-close").hide();
                        $('.ui-dialog .ui-dialog-buttonpane').show();
                    });

                    $('.ux-dialog').on('click', "input#confirm-user-type-two", function () {
                        $('.ui-dialog .content-confirm-conflict').show();
                    });
                    $('.ux-dialog').on('click', "input#confirm-user-type-one", function () {
                        $('.ui-dialog .content-confirm-conflict').hide();
                    });

                    //Activate Confirm Button
                    $('.ux-dialog').on('click', "input#confirm-disclaimer", function () {
                        if ($(this).prop("checked") === true) {
                            $('.ui-dialog-buttonpane .btn-confirm-inactive').removeClass("btn-confirm-inactive").addClass("btn-confirm-active");
                        } else {
                            $('.ui-dialog-buttonpane .btn-confirm-active').removeClass("btn-confirm-active").addClass("btn-confirm-inactive");
                        }

                    });
                };
                init();
            },
            addK1Dialog: function (confirmUrl, formUrl, changePasswordUrl) {
                $.ajax({
                    cache: false,
                    url: confirmUrl,
                    dataType: "json",
                    success: function (data) {
                        if (data) {
                            if (data.indexOf('Activation') >= 0) {
                                $confirm = $('<div>', { "data-action-url": formUrl, "data-display-width": 1000 , "data-display-height": 594, "data-action-type": "modal", "data-title": "User Activation", "data-close-disabled": true });
                                common.ui.dialog($confirm);
                            }
                            else if (data.indexOf('ChangePassword') >= 0) {
                                common.ui.helper.initChangePasswordDialog(changePasswordUrl);
                            }
                        }
                    }
                });
            },
            confirmDialog: function (confirmUrl, formUrl, changePasswordUrl) {
                $.ajax({
                    cache: false,
                    url: confirmUrl,
                    dataType: "json",
                    success: function (data) {
                        if (data) {
                            if (data.indexOf('Activation') >= 0) {
                                $confirm = $('<div>', { "data-action-url": formUrl, "data-display-width": 1000, "data-display-height": 594, "data-action-type": "modal", "data-title": "User Activation", "data-close-disabled": true });
                                common.ui.dialog($confirm);
                            }
                            else if (data.indexOf('ChangePassword') >= 0) {
                                common.ui.helper.initChangePasswordDialog(changePasswordUrl);
                            }
                        } else {
                            // Launch1 Context Help Inital Experience
                            if ($('tbody.tps-association-empty').length === 1) {
                                mlp.helpers.firstTimeExperience('add');
                            }
                        }
                    }
                });
            },
            initChangePasswordDialog = function (changePasswordUrl) {
                //Launch Confirm Dialog
                $changePasswordModal = $('<div>', { "data-action-url": changePasswordUrl, "data-display-width": 380, "data-action-type": "modal", "data-display": "forcedPasswordChange", "data-title": "Change Password", "data-close-disabled": true });
                common.ui.dialog($changePasswordModal);
            },
            unauthenticatedDialog: function (url, confirmEmailUrl, assoctiationRequestUrl, mfaUrl) {
                $.ajax({
                    cache: false,
                    url: url,
                    dataType: "json",
                    success: function (data) {
                        if (data) {
                            //Display user activation if register email link clicked within timeframe in config setting
                            if (data.indexOf('Email') >= 0) {
                                initConfirmEmailDialog();
                            }
                            else if (data.indexOf('MFA') >= 0) {
                                initMfa();
                            }
                            else if (data.indexOf('FederatedRedirectError') >= 0) {
                                displayFederatedSignInError();
                            }
                            else {
                                initAssociationRequestDecisionDialog(data);
                            }
                        }
                    }
                });

                var initConfirmEmailDialog = function () {
                    //Launch Confirm Dialog
                    $emailConfirmedModal = $('<div>', { "data-action-url": confirmEmailUrl, "data-display-width": 380, "data-display-height": 200, "data-action-type": "modal", "data-title": "Email Confirmed", "data-close-disabled": false, "data-display": "gainLoss" });
                    common.ui.dialog($emailConfirmedModal);
                };

                var initMfa = function () {
                    $mfaModal = $('<div>', { "data-action-url": mfaUrl, "data-display-width": 365, "data-action-type": "modal", "data-title": "Verify Device" });
                    common.ui.dialog($mfaModal);
                };

                var initAssociationRequestDecisionDialog = function (message) {
                    var url = assoctiationRequestUrl + "?message=" + message;
                    $decision = $('<div>', { "data-action-url": url, "data-display-width": 380, "data-display-height": 200, "data-action-type": "modal", "data-title": "K1 Association Request Decision", "data-close-disabled": false, "data-display": "gainLoss" });
                    common.ui.dialog($decision);
                };

                var displayFederatedSignInError = function () {
                    $("#user-auth-selection a[data-id='signin']").click();
                    $("#sign-in-error-message-row").show();
                    $('#sign-in-error-message').html("<i class='fa fa-times'></i>There was an issue completing the sign in request. Please try again later.");
                };
            },
            showDialogSubmitAnimation: function () {
                var height = ($('.ui-dialog .ui-dialog-content').height() / 2) - 39;
                $('.ui-dialog .ui-dialog-content').html("");
                var html = '<div class="ux-loading" style="margin-top:' + height + 'px; margin-bottom:' + height + 'px"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div>';
                $('.ui-dialog .ui-dialog-content').html(html);
            },
            showConfirmSubmitAnimation: function () {
                $(".ui-dialog .ui-dialog-content").addClass("confirm-loading-animation");
                var html = '<div class="ux-loading"><i class="fa fa-spinner fa-pulse fa-3x fa-fw confirm-loading-icon"></i></div>';
                $('#confirm-loading-animation').html(html);
                $('#confirm-loading-animation').show();
            },
            hideConfirmSubmitAnimation: function () {
                $(".ui-dialog .ui-dialog-content").removeClass("confirm-loading-animation");
                $('#confirm-loading-animation').html('');
                $('#confirm-loading-animation').hide();
                $(".btn-primary").removeClass("disabled-button");
            },
            hideDialogSubmitAnimation: function () {
                $('.ui-dialog .ui-dialog-content').html("");
            },
            encodeInput: function (unsafeString) {
                return $('<div>').text(unsafeString).html();
            },
            //Copied over from jQuery library
            isNumeric: function (obj) {

                // As of jQuery 3.0, isNumeric is limited to
                // strings and numbers (primitives or objects)
                // that can be coerced to finite numbers (gh-2662)
                var type = typeof obj;
                return (type === "number" || type === "string") &&

                    // parseFloat NaNs numeric-cast false positives ("")
                    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
                    // subtraction forces infinities to NaN
                    !isNaN(obj - parseFloat(obj));
            },
            //Copied over from jQuery library
            trim: function (text) {
                var whitespace = "[\\x20\\t\\r\\n\\f]";
                var rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");

                return text == null ?
                    "" :
                    (text + "").replace(rtrim, "");
            }
        },
        init: {
            experience: function () {

                $(document).on("mouseover", ".ux-tooltip", function () {
                    $(this).tooltip({
                        tooltipClass: "ux-tooltip",
                        position: { my: "center bottom-10", at: "center top" }
                    });
                });

                //Modification Icon Group and OnHover Row Experience
                $classMatched = "row-matched";

                $(document).on("mouseenter", ".modify-icon-cell", function () {
                    $currRow = $(this).closest("tr");
                    $currMatchedId = $currRow.data("row-matched");
                    $currTable = $("#AssociationTable");

                    $("tr", $currTable).each(function () {
                        if ($(this).data("row-matched") === $currMatchedId) {
                            $(this).addClass($classMatched);
                        }
                    });
                });

                $(document).on("mouseleave", ".modify-icon-cell", function () {
                    $("tr", $currTable).removeClass($classMatched);
                });

                //Clicks Drive all Modals
                $("body").on("click", "a[data-action-type='modal'], button[data-action-type='modal'], td[data-action-type='modal']", function (e) {
                    common.ui.dialog($(this));
                    e.preventDefault();
                });

                $("#user-dropdown a[data-action-type='modal']").click(function (e) {
                    common.ui.dialog($(this));
                    e.preventDefault();
                });

                $("#ForgotPasswordLink a[data-action-type='modal']").click(function (e) {
                    common.ui.dialog($(this));
                    e.preventDefault();
                });

                //Activate Dropdown
                $('.ux-dropdown .dropdown-toggle').click(function (e) {
                    var $e = $(this),
                        $parent = $e.parent();
                    $parent.find('.dropdown-content').slideToggle(500, function () {
                        $parent.toggleClass('dropdown-active', $(this).is(':visible'));
                    });
                    e.preventDefault();
                    $('.article-content-grid tr').removeClass('selected');
                });
                $('.ux-dropdown').click(function (e) {
                    e.stopPropagation();
                });
                $('html').click(function () {
                    $('.ux-dropdown .dropdown-content').slideUp().parents('.ux-dropdown').removeClass('dropdown-active');
                    $('.article-content-grid tr').removeClass('selected');
                });

                $(document).on('click', '.hidden-trigger', function (e) {
                    $('.article-content-grid tr').removeClass('selected');
                    $('.ux-dropdown .dropdown-content').slideUp().parents('.ux-dropdown').removeClass('dropdown-active');
                    $(this).parents('tr').addClass('selected');
                    e.stopPropagation();
                });

                function clearChecks(c) {
                    $(c).find("input").removeAttr("checked");
                }

                $("body").on("click", "#wizard-one input", function (e) {
                    var $currVal = $(this).val();
                    if ($currVal === "False") {
                        $("#wizard-two").slideDown();

                        $("#wizard-one-yes").slideUp();
                        $("#wizard-two-yes").slideUp();
                        $("#wizard-three").slideUp();
                        $("#wizard-three-yes").slideUp();
                        $("#wizard-four").slideUp();

                    }
                    if ($currVal === "True") {
                        $("#wizard-one-yes").slideDown();

                        $("#wizard-two").slideUp();
                        $("#wizard-two-yes").slideUp();
                        $("#wizard-three").slideUp();
                        $("#wizard-three-yes").slideUp();
                        $("#wizard-four").slideUp();


                    }
                    clearChecks($("#wizard-two"));
                    clearChecks($("#wizard-three"));
                });

                $("body").on("click", "#wizard-two input", function (e) {
                    var $currVal = $(this).val();
                    if ($currVal === "False") {

                        $("#wizard-three").slideDown();

                        $("#wizard-two-yes").slideUp();
                        $("#wizard-three-yes").slideUp();
                        $("#wizard-four").slideUp();

                        clearChecks($("#wizard-three"));
                    }
                    if ($currVal === "True") {
                        $(".input-date input").datepicker();
                        $("#wizard-two-yes").slideDown();

                        $("#wizard-three").slideUp();
                        $("#wizard-three-yes").slideUp();
                        $("#wizard-four").slideUp();

                        clearChecks($("#wizard-three"));
                    }
                });

                $("body").on("click", "#wizard-three input", function (e) {
                    var $currVal = $(this).val();
                    if ($currVal === "False") {
                        $("#wizard-three-yes").slideUp();
                        $("#wizard-four").slideDown();
                    }
                    if ($currVal === "True") {
                        $("#wizard-three-yes").slideDown();
                        $("#wizard-four").slideUp();
                    }
                });
            },
            userControl: function () {

            },
            actionAddModal: function (type) {
                $('.ux-dialog').on('click', ".ux-action.action-edd", function () {
                    common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-edd'), $('.ux-action-add-dialog-toggle'));
                    $('.ui-dialog .ui-dialog-buttonpane').hide();
                    $("#confirm-modal").parent().removeClass("auto-height-modal");
                    $("#confirm-modal").parent().addClass("fixed-height-modal");
                    $("#confirm-modal").parent().removeClass("overflow-hidden");
                    $("#confirm-modal").parent().addClass("overflow-inherit");
                    $("#confirm-modal").parent().parent().addClass("overflow-width-k1");
                    $(".confirm-header-newux").addClass("k1-terms-hidden");
                });
                $('.ux-dialog').on('click', ".helper-actions-paperless", function () {
                    common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-edd'), $('.ux-action-add-dialog-toggle'));
                    $('.ui-dialog .ui-dialog-buttonpane').hide();
                    $("#confirm-modal").parent().removeClass("auto-height-modal");
                    $("#confirm-modal").parent().addClass("fixed-height-modal");
                    $("#confirm-modal").parent().removeClass("overflow-hidden");
                    $("#confirm-modal").parent().addClass("overflow-inherit-k1");
                });
                $('.ux-dialog').on('click', ".ux-action.action-edd-close", function () {
                    $("#confirm-modal").parent().scrollTop(0);
                    $("#confirm-modal").parent().addClass("overflow-hidden");
                    $("#confirm-modal").parent().parent().removeClass("overflow-width-k1");
                    $("#confirm-modal").parent().removeClass("fixed-height-modal");
                    $("#confirm-modal").parent().removeClass("overflow-inherit-k1");
                    $("#confirm-modal").parent().addClass("auto-height-modal");
                    $("#confirm-modal").parent().removeClass("overflow-inherit");
                    $(".confirm-header-newux").removeClass("k1-terms-hidden");
                    if($("#ActiveSection").val() == null){
                        $(".ui-dialog-title").html("Please Confirm");
                    }
                    common.ui.helper.showHideToggle($('.ux-action-add-dialog-toggle'), $('.ux-dialog .content-confirm-edd'));
                    $("#confirm-modal").parent().removeClass("fixed-height-modal");
                    $('.ui-dialog .ui-dialog-buttonpane').show();
                });

                var showHideAccountNumber = function () {
                    if ($("#addK1Single input[id *= 'IsForeignEnabledForAccount']").prop('checked')) {
                        $("#addK1Single [data-element='IsForeignEnabledForAccount']").slideDown();
                        $("#addK1Single [data-element='IsForeignDisabledForAccount']").slideUp();
                    } else {
                        $("#addK1Single [data-element='IsForeignEnabledForAccount']").slideUp();
                        $("#addK1Single [data-element='IsForeignDisabledForAccount']").slideDown();
                    }
                }

                var showHideVerifyOptions = function (isOwner) {
                    $("#addK1Single #verify-identity-option").hide();
                    $("#addK1Single #verify-identity-option-disabled").hide();

                    if ($("#addK1Single input[id *= 'IsForeignEnabledForAccount']").prop('checked')) {
                        if (isOwner) {
                            $("#addK1Single #verify-identity-option-disabled").show();
                        }
                        $("#addK1Single #account-number-option").hide();
                        $("#addK1Single #account-number-option-disabled").show();
                    } else {
                        if (isOwner) {
                            $("#addK1Single #verify-identity-option").show();
                        }
                        $("#addK1Single #account-number-option").show();
                        $("#addK1Single #account-number-option-disabled").hide();
                    }
                }

                var updateLayout = function () {
                    var isOwner = $("#TPSAccessControlTypeID").val() === "1";
                    showHideAccountNumber();
                    showHideVerifyOptions(isOwner);
                }

                $("#principalSelection").on("click", function () {
                    if (!$(this).hasClass("access-type-disable-tiles")) {
                        $("#select-option-section .ux-column").removeClass("access-type-disable-selections");
                        $(this).removeClass("access-type-unselected").removeClass("access-type-invalid").addClass("access-type-selected");
                        $("#limitedSelection").removeClass("access-type-selected").removeClass("access-type-invalid").addClass("access-type-unselected");
                        $("#TPSAccessControlTypeID").val(1);
                        $("#otherOptions").show();
                        updateLayout();
                        $(".ui-dialog-title").html("Add K-1: Owner");
                    }
                });

                $("#limitedSelection").on("click", function () {
                    if (!$(this).hasClass("access-type-disable-tiles")) {
                        $("#select-option-section .ux-column").removeClass("access-type-disable-selections");
                        $(this).removeClass("access-type-unselected").removeClass("access-type-invalid").addClass("access-type-selected");
                        $("#principalSelection").removeClass("access-type-selected").removeClass("access-type-invalid").addClass("access-type-unselected");
                        $("#TPSAccessControlTypeID").val(2);
                        $("#otherOptions").hide();
                        updateLayout();
                        $(".ui-dialog-title").html("Add K-1: Delegate");
                    }
                });

                //Clicks Drive all Modal Tabs
                $('body').on('click', ".tabs-in-dialog a", function () {
                    var $t = $(this).data('tab-id');
                    $(this).parents('.ux-action-modal').find('.action-modal-content').hide().removeClass('modal-content-active');
                    $(this).closest('ul').find('li').removeClass('selected');
                    $(this).parents('.ux-action-modal').find('[data-tab-content=' + $t + ']').show().addClass('modal-content-active');
                    $(this).closest('li').addClass('selected');
                });

                ///////////////////////////////////
                //For Single Only

                //Inital Check on ForeignAccount
                if ($("#addK1Single input[id*='IsForeignEnabledForAccount']:checked").length > 0) {
                    $("#addK1Single [data-element='IsForeignEnabledForAccount']").show();
                    $("#addK1Single [data-element='IsForeignDisabledForAccount']").hide();
                } else {
                    $("#addK1Single [data-element='IsForeignEnabledForAccount']").hide();
                    $("#addK1Single [data-element='IsForeignDisabledForAccount']").show();
                }

                $('body').on('click', "#NonUSTaxpayerClickHere", function (e) {
                    $("#addK1Single input[id *= 'IsForeignEnabledForAccount']").prop("checked", true);
                    updateLayout();
                });

                $('body').on('click', "#USTaxpayerClickHere", function (e) {
                    $("#addK1Single input[id *= 'IsForeignEnabledForAccount']").prop("checked", false);
                    updateLayout();
                });

                initVerification();

                //Initial selection MUST BE AFTER initVerification()
                if ($("#TPSAccessControlTypeID").val() === "1") {
                    $("#principalSelection").addClass("access-type-selected");
                    $("#otherOptions").show();
                    updateLayout();
                } else if ($("#TPSAccessControlTypeID").val() === "2") {
                    $("#limitedSelection").addClass("access-type-selected");
                    updateLayout();
                } else if ($(".general-information-error span").html() === "Access Type selection is required.") {
                    $("#principalSelection").addClass("access-type-invalid");
                    $("#limitedSelection").addClass("access-type-invalid");
                    updateLayout();
                }

                if ($('#current-window-input').val() !== "None" && $('#current-window-input').val() !== "") {
                    $("#limitedSelection, #principalSelection").addClass("access-type-disable-tiles");
                }

                function initVerification() {

                    showHideVerifyOptions(false);

                    var isAssociationVerified = $("#addK1Single input[name='Verification.IsVerified']").val();

                    if (isAssociationVerified === "True") {
                        $("body").on("change", "#addK1Single  input[name='TaxIdentificationNumber'], #addK1Single  input[name='TaxForeignIdentificationNumber']", function () {

                            if ($("#addK1Single input[name='Verification.IsVerified']").val() !== "False") {
                                $("#addK1Single input[name='Verification.IsVerified']").val("False");
                                $("#addK1Single .verification-column").show();
                            }
                        });
                    }

                    var verification1 = $("#wizard-one input:checked").val();
                    var verification2 = $("#wizard-two input:checked").val();
                    var verification3 = $("#wizard-three input:checked").val();

                    if (verification1 === "True") {
                        $("#wizard-one-yes").show();
                    }
                    else if (verification1 === "False") {
                        $("#wizard-two").show();

                        if (verification2 === "True") {
                            $(".input-date input").datepicker();
                            $("#wizard-two-yes").show();
                        }
                        else if (verification2 === "False") {
                            $("#wizard-three").show();

                            if (verification3 === "True") {
                                $("#wizard-three-yes").show();
                            }
                            else if (verification3 === "False") {
                                $("#wizard-four").show();
                            }
                        }
                    }
                }
            },
            actionOwnershipModal: function (reloadUrl) {

                $('body').on('click', ".tabs-in-dialog a", function (e) {
                    var $t = $(this).data('tab-id');
                    $(this).parents('.ux-action-modal').find('.action-modal-content').hide().removeClass('modal-content-active');
                    $(this).closest('ul').find('li').removeClass('selected');
                    $(this).parents('.ux-action-modal').find('[data-tab-content=' + $t + ']').show().addClass('modal-content-active');
                    $(this).closest('li').addClass('selected');
                });

                var viewOwnershipGeneral = "div[id='ownershipViewGeneral']",
                    editOwnershipGeneral = "div[id='ownershipEditGeneral']",
                    viewOwnershipTransactions = "div[id='ownershipViewTransactions']",
                    editOwnershipTransactions = "div[id='ownershipEditTransactions']";

                //Edit Buttons
                $('body').off('click', ".btn-editOwnershipGeneral").on('click', ".btn-editOwnershipGeneral", function (e) {
                    if ($("#HasPendingGeneralEdits").val() === "False") {
                        $(editOwnershipGeneral).show();
                        $(viewOwnershipGeneral).hide();
                        e.preventDefault();
                    }
                });

                $('body').off('click', ".btn-editOwnershipTransactions").on('click', ".btn-editOwnershipTransactions", function (e) {
                    if ($("#HasPendingTransactionEdits").val() === "False") {
                        $(editOwnershipTransactions).show();
                        $(viewOwnershipTransactions).hide();
                        e.preventDefault();
                    }
                });

                // Cancel Buttons
                $('body').off('click', ".btn-cancelOwnershipGeneral").on('click', ".btn-cancelOwnershipGeneral", function (e) {
                    $(editOwnershipGeneral).hide();
                    $(viewOwnershipGeneral).show();
                    e.preventDefault();
                });

                $('body').off('click', ".btn-cancelOwnershipTransactions").on('click', ".btn-cancelOwnershipTransactions", function (e) {
                    $.ajax({
                        url: reloadUrl,
                        cache: false,
                        success: function (data) {
                            $('#ownershipInformation').html(data);
                        }
                    });
                    e.preventDefault();
                });

                //Show/Hide state based on IsDomestic flag
                $('body').off('click', "#editK1Ownership input[id*='IsForeign']").on('click', "#editK1Ownership input[id*='IsForeign']", function () {
                    if ($(this).prop('checked')) {
                        $(this).parents("row").find("[data-element='Country']").show();
                        $(this).parents("div").find("[data-element='Country']").show();

                        $(this).parents("row").find("#StateCodeID")[0].selectedIndex = 0;
                        $(this).parents("row").find("[data-element='State']").hide();
                        $(this).parents("div").find("[data-element='State']").hide();

                        $(this).parents("row").find("#ZipCodeNumber").val('');
                        $(this).parents("row").find("[data-element='ZipCode']").hide();
                        $(this).parents("div").find("[data-element='ZipCode']").hide();
                    } else {
                        $(this).parents("row").find("#CountryID")[0].selectedIndex = 0;
                        $(this).parents("row").find("[data-element='Country']").hide();
                        $(this).parents("div").find("[data-element='Country']").hide();

                        $(this).parents("row").find("[data-element='State']").show();
                        $(this).parents("div").find("[data-element='State']").show();

                        $(this).parents("row").find("[data-element='ZipCode']").show();
                        $(this).parents("div").find("[data-element='ZipCode']").show();
                    }
                });

                //Creating a Ownership Row
                $('body').off('click', "#editK1Transactions td > a[data-action-type='add']").on('click', "#editK1Transactions td > a[data-action-type='add']", function (e) {
                    if (e.handled !== true) // This will prevent event triggering more then once
                    {
                        var $p = $(this).parents('table').find('tbody'),
                            $rows = $p.find('tr'),
                            $rowCount = $p.find('tr').length,
                            $lastRow = $rows.last();
                        $blankRow = $("#rowTemplate").find('tbody').html();
                        $p.append($blankRow); //[NEW ADDING ROW METHOD]
                        common.ui.helper.updateClonedMultipleTransaction($p);
                        //We are going to remove the class if it's there to hide the bulk button
                        $(this).parents("form.ux-forms").removeClass('bulk-add-active');
                        e.handled = true;
                    }
                    e.preventDefault();
                });

                //Delete Ownership Row
                $('body').off('click', "#editK1Transactions td > a[data-action-type='delete']").on('click', "#editK1Transactions td > a[data-action-type='delete']", function (e) {
                    var $c = $(this).parents('tr'),
                        $p = $c.parents('tbody'),
                        $count = $c.length;
                    if ($count >= 0) {
                        $c.remove();
                        common.ui.helper.updateClonedMultipleTransaction($p);
                        updateBalance();
                    }
                    e.preventDefault();
                });

                $('body').off('click', ".btn-saveOwnershipTransactions, .btn-saveOwnershipGeneral").on('click', ".btn-saveOwnershipTransactions, .btn-saveOwnershipGeneral", function (e) {
                    var $h = {
                        removeComma: function (val) {
                            val = val.replace(/\,/g, '');
                            val = parseInt(val);
                            return val;
                        },
                        removeFloatComma: function (val) {
                            val = val.replace(/\,/g, '');
                            val = parseFloat(val).toFixed(5);
                            return val;
                        },

                        formatInput: function () {
                            $("#ownershipInformationTransactionTable td#ownershipInformationTransactionAmount input").each(function () {

                                var transactionAmount = common.ui.helper.trim($(this).val());
                                var temp;
                                if (transactionAmount !== "") {
                                    temp = $h.removeComma(transactionAmount);

                                    if (common.ui.helper.isNumeric(temp) === true) {
                                        transactionAmount = temp;
                                    }
                                } else {
                                    transactionAmount = 0;
                                }
                                $(this).val(transactionAmount);
                            });

                            $("#ownershipInformationTransactionTable td#ownershipInformationTransactionUnits input").each(function () {
                                var transactionUnits = $(this).val();
                                var temp;
                                if (transactionUnits !== "") {
                                    temp = $h.removeFloatComma(transactionUnits);

                                    if (common.ui.helper.isNumeric(temp) === true) {
                                        transactionUnits = temp;
                                    }
                                } else {
                                    transactionUnits = "";
                                }
                                $(this).val(transactionUnits);
                            });
                        }
                    };
                    $h.formatInput();
                });

                $('body').off('keyup', '.ownership-transactionDate').on('keyup', '.ownership-transactionDate', onTransactionDateKeyUp);
                $('body').off('change', '.ownership-transactionDate').on('change', '.ownership-transactionDate', onTransactionDateChanged);

                $('body').off('change', "#ownershipInformationTransactionTable td#ownershipInformationTransactionAmount input")
                    .on('change', "#ownershipInformationTransactionTable td#ownershipInformationTransactionAmount input", onTransactionAmountChanged);

                $('body').off('keyup', '.ownership-transactionUnits').on('keyup', '.ownership-transactionUnits', onTransactionUnitsKeyUp);
                $('body').off('change', '.ownership-transactionUnits').on('change', '.ownership-transactionUnits', onTransactionUnitsChanged);

                $('body').off('click', '.ownership-transactionCheckbox').on('change', '.ownership-transactionCheckbox', onTransactionTypeChanged);

                $('body').on('focus', '#ownershipInformationTransactionTable input', onTransactionInputFocus);

                function onTransactionInputFocus(e) {
                    $("#ownershipInformationTransactionTable tr").removeClass('row-active');
                    $(this).parents("tr").addClass('row-active');
                }

                function onTransactionTypeChanged(e) {
                    $(this).val($(this).prop("checked"));
                    updateBalance();
                }

                function onTransactionUnitsKeyUp(e) {
                    if (e.which === 0 || (e.which >= 37 && e.which <= 40)) return;
                    updateBalance();
                }

                function onTransactionDateKeyUp(e) {

                    var isIE = isExplorer();

                    if (!isIE) {
                        if (e.which === 0 || (e.which >= 37 && e.which <= 40)) return;
                    }

                    var value = $(this).val();
                    var isValid = isValidDate(value);

                    if (isValid) {
                        var reoder = sortTransactionTable(isIE);

                        if (isIE) {
                            $(this).parents("tr").find(".ownership-transactionUnits").focus();
                            $(this).focus();
                        }
                        else if (reoder) {
                            $(this).focus();
                        }

                        if (reoder) {
                            common.ui.helper.updateClonedMultipleTransaction($(this).parents('table').find('tbody'));
                            updateBalance();
                        }
                    }
                }

                function isExplorer() {

                    var ua = window.navigator.userAgent;
                    var msie = ua.indexOf("MSIE ");

                    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                        return true;
                    }

                    return false;
                }

                function isValidDate(value) {
                    var check = false;
                    var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                    if (re.test(value)) {
                        var adata = value.split('/');
                        var mm = parseInt(adata[0], 10);
                        var dd = parseInt(adata[1], 10);
                        var yyyy = parseInt(adata[2], 10);
                        var xdata = new Date(yyyy, mm - 1, dd);
                        if ((xdata.getFullYear() === yyyy) && (xdata.getMonth() === mm - 1) && (xdata.getDate() === dd))
                            check = true;
                        else
                            check = false;
                    } else
                        check = false;

                    return check;
                }

                function sortTransactionTable(isIE) {

                    var $table = $('#ownershipInformationTransactionTable');
                    var $rows = $('tbody > tr', $table);
                    $table.find('input').removeClass('input-active');
                    $table.find('input:focus').addClass('input-active');
                    var reorder = false;

                    for (var i = 0; i < $rows.length - 1; i++) {
                        if (!reorder && compareRows($rows[i], $rows[i + 1]) > 0) {
                            reorder = true;
                        }
                    }

                    if (reorder) {
                        $rows.sort(compareRows);
                        $rows.sort(compareRows);

                        $.each($rows, function (index, row) {
                            $table.append(row);
                        });

                        // Pulsate Current Row
                        if (isIE) $table.find('.input-active').parents('tr').find('td').stop().fadeTo(200, .6).fadeTo(200, 1).fadeTo(200, .6).fadeTo(200, 1);
                        else $table.find('.input-active').parents('tr').stop().fadeTo(200, .6).fadeTo(200, 1).fadeTo(200, .6).fadeTo(200, 1);

                        return true;
                    }

                    return false;
                }

                function updateBalance() {
                    var $table = $('#ownershipInformationTransactionTable');
                    var $rows = $('tbody > tr', $table);
                    var balance = 0;

                    $.each($rows, function (index, row) {

                        var units = parseFloat($(row).find(".ownership-transactionUnits").val().replace(/,/g, ""));
                        var isDisposition = false;

                        if ($(row).find(".ownership-transactionType").length > 0) {
                            var dataIsDisposition = $(row).find(".ownership-transactionType").data("is-disposition");

                            isDisposition = dataIsDisposition === "True";
                        }
                        else {
                            isDisposition = $(row).find(".ownership-transactionCheckbox").is(":checked");
                        }

                        balance = balance + units * (isDisposition ? -1 : 1);

                        if (balance < 0 && !$(row).find(".ownership-transactionBalance span").hasClass("ownership-transactionBalance-negative")) {
                            $(row).find(".ownership-transactionBalance span").addClass("ownership-transactionBalance-negative");
                        }

                        if (balance > 0 && $(row).find(".ownership-transactionBalance span").hasClass("ownership-transactionBalance-negative")) {
                            $(row).find(".ownership-transactionBalance span").removeClass("ownership-transactionBalance-negative");
                        }

                        $(row).find(".ownership-transactionBalance span").html(numberWithCommas(balance.toFixed(5)));
                    });

                    if (balance < 0 && !$("#ownershipInformationTransactionTable .ownership-transactionTotalBalance span").hasClass("ownership-transactionBalance-negative")) {
                        $("#ownershipInformationTransactionTable .ownership-transactionTotalBalance span").addClass("ownership-transactionBalance-negative");
                    }

                    if (balance > 0 && $("#ownershipInformationTransactionTable .ownership-transactionTotalBalance span").hasClass("ownership-transactionBalance-negative")) {
                        $("#ownershipInformationTransactionTable .ownership-transactionTotalBalance span").removeClass("ownership-transactionBalance-negative");
                    }

                    $("#ownershipInformationTransactionTable .ownership-transactionTotalBalance span").html(numberWithCommas(balance.toFixed(5)));
                }

                function numberWithCommas(x) {
                    var parts = x.toString().split(".");
                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return parts.join(".");
                }

                function compareRows(a, b) {
                    var keyA = $('td .ownership-transactionDate', a).val();
                    var keyB = $('td .ownership-transactionDate', b).val();

                    var dateAIsValid = isValidDate(keyA);
                    var dateBIsValid = isValidDate(keyB);

                    if (!dateAIsValid && !dateBIsValid) {
                        return 1;
                    }
                    else if (dateAIsValid && dateBIsValid) {
                            return (new Date(keyA) > new Date(keyB)) ? 1 : -1;
                        }    
                    else if (dateAIsValid) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }

                function onTransactionDateChanged() {
                    var value = $(this).val();
                    var elementIndex = getElementIndex(this);

                    if (isValidDate(value)) clearValidationError(this);
                    else addValidationError(this, elementIndex, "TransactionDate", "The value '" + common.ui.helper.encodeInput(value) + "' is not valid for TransactionDate.");

                }

                function onTransactionAmountChanged() {

                    var value = $(this).val();
                    var elementIndex = getElementIndex(this);

                    var formattedValue = value.replace(/\,/g, '').replace(/\$/g, '').replace(/#/g, '');
                    var numberValue = parseFloat(formattedValue);

                    if (common.ui.helper.isNumeric(numberValue)) {
                        if (numberValue > 0 && numberValue === parseInt(formattedValue)) {
                            clearValidationError(this);
                            $(this).val(numberWithCommas(numberValue));
                        }
                        else addValidationError(this, elementIndex, "TransactionAmount", "Invalid Transaction Amount. Whole positive numbers only.");
                    }
                    else {
                        addValidationError(this, elementIndex, "TransactionAmount", "The value '" + common.ui.helper.encodeInput(value) + "' is not valid for TransactionAmount.");
                    }
                }

                function onTransactionUnitsChanged() {

                    var value = $(this).val();
                    var elementIndex = getElementIndex(this);

                    var formattedValue = value.replace(/\,/g, '').replace(/\$/g, '').replace(/#/g, '');
                    var numberValue = parseFloat(formattedValue);
                    var numberOfDecimalPoints = (formattedValue.match(/\./g) || []).length;

                    if (numberOfDecimalPoints < 2 && common.ui.helper.isNumeric(numberValue)) {

                        if (numberValue > 0) {
                            clearValidationError(this);
                            $(this).val(numberWithCommas(numberValue.toFixed(5)));
                        }
                        else addValidationError(this, elementIndex, "TransactionUnits", "Invalid Units Amount. Positive numbers with maximum 5 decimal points only.");
                    }
                    else {
                        addValidationError(this, elementIndex, "TransactionUnits", "The value '" + common.ui.helper.encodeInput(value) + "' is not valid for TransactionUnits.");
                    }

                    updateBalance();
                }

                function getElementIndex(element) {
                    var name = $(element).attr("name");
                    var startIndex = name.indexOf("[");
                    var endIndex = name.indexOf("]");

                    var elementIndex = name.slice(startIndex + 1, endIndex);

                    return elementIndex;
                }

                function clearValidationError(element) {
                    $(element).siblings(".error-icon").html("");
                    $(element).parent().removeClass("input-error");
                }

                function addValidationError(element, index, elementName, message) {

                    var validationMessage = document.createElement("span");

                    validationMessage.setAttribute("class", "field-validation-error");
                    validationMessage.setAttribute("data-valmsg-replace", "true");
                    validationMessage.setAttribute("data-valmsg-for", `TransactionViewModel[${index}].${elementName}`);
                    validationMessage.innerHTML = common.ui.helper.encodeInput(message);

                    $(element).siblings(".error-icon").html(validationMessage);
                    $(element).parent().addClass("input-error");
                }
            },
            confirm: function (activeSection, isPartnership, isTwilioEnabled, lookupTPSUserTypeID, hasError, twoFactorSection) {
                $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable').addClass("auto-height-modal");
                $( ".ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable").draggable({
                    stop: function(event, ui) {
                          $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable').addClass("auto-height-modal");
                    }
                })

                if ($("a[data-selected = 'selected']").length > 0) {
                    $("a[data-selected = 'selected']").click();
                }

                $("#confirm-animated-icon-0").tooltipster({
                    trigger: 'hover',
                    onlyOne: false,
                    position: 'top',
                    maxWidth:'150'
                });

                $("#confirm-animated-icon-1").tooltipster({
                    trigger: 'hover',
                    onlyOne: false,
                    position: 'top',
                    maxWidth:'150'
                });

                $("#confirm-animated-icon-2").tooltipster({
                    trigger: 'hover',
                    onlyOne: false,
                    position: 'top',
                    maxWidth:'150'
                });

                $("#confirm-animated-icon-3").tooltipster({
                    trigger: 'hover',
                    onlyOne: false,
                    position: 'top',
                    maxWidth:'150'
                });

                $(".box-type").click(function () {
                    $('#select-user-type-partial .box-type-row-confirm-error').hide();
                    if ($(this).children().first().data("user-type-id") === 1)
                    {
                        $(".content-confirm-newux").attr('class', function(i, val){ return val.replace(/(^|\s)select\S+/g, ''); });
                        $(".content-confirm-newux").addClass("select-user-type-1");
                        $(".kba-carousel").attr('class', function(i, val){ return val.replace(/(^|\s)height\S+/g, ''); });
                        $(".kba-carousel").addClass("height-user-type-1");
                        $(".confirm-user-type-switch").show();
                    }
                    else
                    {
                        $(".content-confirm-newux").attr('class', function(i, val){ return val.replace(/(^|\s)select\S+/g, ''); });
                        $(".content-confirm-newux").addClass("select-user-type-2");
                        $(".kba-carousel").attr('class', function(i, val){ return val.replace(/(^|\s)height\S+/g, ''); });
                        $(".kba-carousel").addClass("height-user-type-2");
                        $(".confirm-user-type-switch").show();
                    }

                    $('.kba-carousel-next').removeClass("disabled-button");
                });

                if (!lookupTPSUserTypeID) {
                    $('.kba-carousel-next').addClass("disabled-button");
                    $(".content-confirm-newux").addClass("select-user-type-0");
                    $(".kba-carousel").addClass("height-user-type-0");
                    $(".confirm-user-type-switch").hide();
                }
                else if (lookupTPSUserTypeID === 1)
                {
                    $(".content-confirm-newux").addClass("select-user-type-1");
                    $(".kba-carousel").addClass("height-user-type-1");
                    $(".confirm-user-type-switch").show();
                    $("#user-info-partial").addClass("auto-height-modal");
                    $("#UserInfoCompanyUserEntry").hide();
                    $('.kba-carousel-next').removeClass("disabled-button");
                    $('[data-user-type-id="1"').trigger("click");
                }
                else
                {
                    $("#UserInfoCompanyUserEntry").show();
                    $('.kba-carousel-next').removeClass("disabled-button");
                    $(".content-confirm-newux").addClass("select-user-type-2");
                    $(".kba-carousel").addClass("height-user-type-2");
                    $(".confirm-user-type-switch").show();
                    $('[data-user-type-id="' + lookupTPSUserTypeID + '"').trigger("click");
                }

                $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable').addClass("resize-none");
                $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable').addClass("center-modal");
                $('.ui-resizable-handle.ui-resizable-se.ui-icon.ui-icon-gripsmall-diagonal-se').remove();

                var currCountryCode = $("#CountryID").find(":selected").val();
                if (currCountryCode === "null")
                {
                    $(".united-states-only").show();
                }
                else
                {
                    $(".united-states-only").hide();
                }

                $("#unitHolderSSNVerification").tooltipster({
                    trigger: 'hover',
                    onlyOne: false,
                    position: 'top',
                    maxWidth: "100",
                    theme: 'tooltipster-light'
                });

                if (activeSection === 0)
                {
                    if (isPartnership)
                    {
                        if (isTwilioEnabled)
                        {
                            $("#kba-status-indicator-confirm-border").addClass("section-0-twilio-partnership");
                        }
                        else
                        {
                             $("#kba-status-indicator-confirm-border").addClass("section-0");
                        }
                    }
                    else
                    {
                        if (isTwilioEnabled)
                        {
                             $("#kba-status-indicator-confirm-border").addClass("section-0");
                        }
                        else
                        {
                             $("#kba-status-indicator-confirm-border").addClass("section-0-non-twilio-non-partnership");
                        }
                    }
                }

                if (activeSection === 1)
                {
                    if (isPartnership)
                    {
                        if (isTwilioEnabled)
                        {
                              $("#kba-status-indicator-confirm-border").addClass("section-1-twilio-partnership");
                        }
                        else
                        {
                              $("#kba-status-indicator-confirm-border").addClass("section-1");
                        }
                    }
                    else
                    {
                        if (isTwilioEnabled)
                        {
                            $("#kba-status-indicator-confirm-border").addClass("section-1");
                        }
                        else
                        {
                            $("#kba-status-indicator-confirm-border").addClass("section-1-non-twilio-non-partnership");
                        }
                    }

                    if ($("#authentication-confirm .box-type-row-confirm-error").val() != null) {
                        if ($(".cxp-active").children().first().data("user-type-id") > 1) {
                        $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                        $(".content-confirm-newux").addClass("select-info-2-error");
                        $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                        $(".kba-carousel").addClass("height-info-2-error");
                    } else {
                        $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                        $(".content-confirm-newux").addClass("select-info-1-error");
                        $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                        $(".kba-carousel").addClass("height-info-1-error");
                    }
                    } else {
                        if ($(".cxp-active").children().first().data("user-type-id") > 1) {
                            $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                            $(".content-confirm-newux").addClass("select-info-2");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-info-2");
                        } else {
                            $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                            $(".content-confirm-newux").addClass("select-info-1");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-info-1");
                    }
                    }
                }

                if (activeSection === 2)
                {
                    if (!isTwilioEnabled && isPartnership) {
                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable').addClass("k1-width-modal");
                        $("#kba-status-indicator-confirm-border").addClass("section-2");
                        $("#confirm-form-modal").addClass("confirm-add-k1-modal");
                        $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)width\S+/g, ''); });
                        $(".kba-carousel").addClass("width-k1");
                        $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                        $(".content-confirm-newux").addClass("select-add-k1");
                        $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                        //hides scroll bars for UA K-1 modal
                        $('.ux-dialog.ui-dialog-content.ui-widget-content').addClass("overflow-hidden");
                    }
                    else
                    {
                        $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });

                        if (hasError) {
                            $(".content-confirm-newux").addClass("select-user-type-1");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-user-type-1");
                        }
                        else {
                            $(".content-confirm-newux").addClass("select-user-type-0");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-user-type-0");
                        }

                        if (!isTwilioEnabled) {
                            if (!isPartnership) {
                                $('.ux-dialog').dialog('close');
                            }
                        }
                        else {
                            switch (twoFactorSection) {
                                case "SendCode":
                                    $('.kba-carousel-next').addClass("disabled-button");
                                    $(".kba-carousel-prev").show();
                                    break;
                                case "VerifyCode":
                                    $('.kba-carousel-next').removeClass("disabled-button");
                                    $(".kba-carousel-prev").show();
                                    break;
                            }
                        }
                        if (isPartnership) {
                            if (isTwilioEnabled) {
                                $("#kba-status-indicator-confirm-border").addClass("section-2-twilio-partnership");
                            }
                            else {
                                $("#kba-status-indicator-confirm-border").addClass("section-2");
                            }
                        }
                        else {
                            $("#kba-status-indicator-confirm-border").addClass("section-2");
                        }
                    }
                }

                if (activeSection === 3)
                {
                    if (!isPartnership) {
                        $('.ux-dialog').dialog('close');
                    }
                    else
                    {
                        $(".ux-dialog").dialog({ position: { my: "center", at: "center", of: window } });
                        $('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable.ui-resizable').addClass("k1-width-modal");
                        $("#kba-status-indicator-confirm-border").addClass("section-3");
                        $("#confirm-form-modal").addClass("confirm-add-k1-modal");
                        $(".kba-carousel").attr('class', function(i, val){ return val.replace(/(^|\s)width\S+/g, ''); });
                        $(".kba-carousel").addClass("width-k1");
                        $(".content-confirm-newux").attr('class', function(i, val){ return val.replace(/(^|\s)select\S+/g, ''); });
                        $(".content-confirm-newux").addClass("select-add-k1");
                        $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                    }
                }

                $(".kba-carousel > div").addClass("siema-slide-transition");
                $("#confirm-modal").parent().addClass("auto-height-modal");
            },
            actionGainLossCalculationModal: function (type) {
                //Format Helpers
                var $h = {
                    // Rounding Decimal Places
                    round: 0,
                    removeComma: function (val) {
                        val = val.replace(/\,/g, '');
                        val = parseInt(val);
                        return val;
                    },
                    removeFloatComma: function (val) {
                        val = val.replace(/\,/g, '');
                        val = parseFloat(val);
                        return val;
                    },
                    addComma: function (val) {
                        while (/(\d+)(\d{3})/.test(val.toString())) {
                            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
                        }
                        return val;
                    },
                    addCommaDecimal: function (val) {
                        while (/(\d+)(\d{3})[.](\d+)?/.test(val.toString())) {
                            var valToFormat = val.toString().split(".");
                            var val1 = $h.addComma(valToFormat[0]);
                            val = val1 + "." + valToFormat[1];
                        }
                        return val;
                    }
                };
                //Elements
                var $e = {
                    tbl: $("#gainLossCalculationTable"),
                    available: $(".output-units-available"),
                    date: "",
                    projectedSalesPrice: $("textbox-projected-sales-price"),
                    sold: $(".output-units-sold"),
                    proceeds: $(".output-sales-proceeds"),
                    unitsProrated: $(".textbox-units-prorated"),
                    purchaseAmount: $(".textbox-purchase-amount"),
                    //Output Value per Row
                    adjustmentBasis: $(".output-cumulative-adjustment-to-basis"),
                    gainLossTotal: $(".output-total-gain-loss"),
                    gainOrdinary: $(".output-ordinary-gain"),
                    gainLossCapital: $(".output-capital-gain-loss"),
                    adjustmentAmt: $(".output-amt-adjustment")
                    //Output Value Footer
                };
                //Calculations
                var calc = {
                    update:
                    {
                        rowCalculations: function ($r) {
                            calc.update.salesProceedsCalculations();
                            $c = {
                                sold: $r.find($e.sold).text(),
                                proceeds: $r.find($e.proceeds).text(),
                                purchaseAmount: $r.find($e.purchaseAmount).val(),
                                available: $r.find($e.available).text(),
                                d: {
                                    price: $r.data("calc-group-price"),
                                    gain: $r.data("calc-ordinary-gain"),
                                    adjustment: $r.data("calc-amount-adjustment"),
                                    perUnitAmount: $r.data("per-unit-amount")
                                }
                            };
                            //Run Calculations and Place in Results
                            var results = calc.run($c);
                            //Update Values
                            $r.find($e.sold).text($h.addCommaDecimal($c.sold));
                            $r.find($e.adjustmentBasis).text($h.addComma(results.adjustmentBasis));
                            $r.find($e.gainLossTotal).text($h.addComma(results.gainLossTotal));
                            $r.find($e.gainOrdinary).text($h.addComma(results.gainOrdinary));
                            $r.find($e.gainLossCapital).text($h.addComma(results.gainLossCapital));
                            $r.find($e.adjustmentAmt).text($h.addComma(results.adjustmentAmt));
                            $r.find($e.purchaseAmount).val($h.addComma(results.purchaseAmount));
                            calc.update.totalCalculations();
                        },
                        totalCalculations: function () {
                            var resultsTotal = {
                                adjustmentBasis: 0,
                                gainLossTotal: 0,
                                gainOrdinary: 0,
                                gainLossCapital: 0,
                                adjustmentAmt: 0
                            };
                            $("tbody tr", $e.tbl).each(function (i) {
                                resultsTotal.adjustmentBasis += parseInt($h.removeComma($(this).find($e.adjustmentBasis).text()));
                                resultsTotal.gainLossTotal += parseInt($h.removeComma($(this).find($e.gainLossTotal).text()));
                                resultsTotal.gainOrdinary += parseInt($h.removeComma($(this).find($e.gainOrdinary).text()));
                                resultsTotal.gainLossCapital += parseInt($h.removeComma($(this).find($e.gainLossCapital).text()));
                                resultsTotal.adjustmentAmt += parseInt($h.removeComma($(this).find($e.adjustmentAmt).text()));
                            });
                            $("tfoot tr", $e.tbl).find($e.adjustmentBasis).text($h.addComma(resultsTotal.adjustmentBasis));
                            $("tfoot tr", $e.tbl).find($e.gainLossTotal).text($h.addComma(resultsTotal.gainLossTotal));
                            $("tfoot tr", $e.tbl).find($e.gainOrdinary).text($h.addComma(resultsTotal.gainOrdinary));
                            $("tfoot tr", $e.tbl).find($e.gainLossCapital).text($h.addComma(resultsTotal.gainLossCapital));
                            $("tfoot tr", $e.tbl).find($e.adjustmentAmt).text($h.addComma(resultsTotal.adjustmentAmt));
                        },
                        salesProceedsCalculations: function () {
                            $("tbody tr", $e.tbl).each(function (i) {
                                var salesProceed = parseFloat($h.removeComma($(this).find($e.sold).text())) * parseFloat($h.removeFloatComma($(".textbox-projected-sales-price").val()));
                                $(this).find($e.proceeds).text($h.addComma(Math.round(salesProceed)));
                            });
                        },
                        setValuesToZero: function ($r) {
                            $r.find($e.sold).text(0.0000.toFixed(4));
                            $r.find($e.proceeds).text(0);
                            $r.find($e.adjustmentBasis).text(0);
                            $r.find($e.gainLossTotal).text(0);
                            $r.find($e.gainOrdinary).text(0);
                            $r.find($e.gainLossCapital).text(0);
                            $r.find($e.adjustmentAmt).text(0);
                            calc.update.totalCalculations();
                        }
                    },
                    run: function ($c) {
                        var v = {
                            purchaseAmount: Math.round($h.removeComma($c.sold) * $c.d.perUnitAmount),
                            gainOrdinary: Math.round($h.removeComma($c.sold) * $c.d.gain),
                            gainLossCapital: null,
                            adjustmentAmt: Math.round($h.removeComma($c.sold) * $c.d.adjustment)
                        };
                        v.adjustmentBasis =
                            Math.round((($c.d.price / $c.available) * $h.removeComma($c.sold)) - v.purchaseAmount);
                        v.gainLossTotal = Math.round(($h.removeComma($c.proceeds) - v.purchaseAmount));
                        v.gainLossTotal = Math.round(v.gainLossTotal - v.adjustmentBasis);
                        v.gainLossCapital = Math.round(v.gainLossTotal - v.gainOrdinary);
                        return v;

                    }
                };

                $(".textbox-units-prorate").blur(function () {
                    var totalUnitsAvailable = 0;
                    var prorateUnits = $(".textbox-units-prorate").val();
                    $("tbody tr", $e.tbl).each(function () {
                        totalUnitsAvailable += parseFloat($(this).find($e.available).text());
                    });
                    if (prorateUnits > totalUnitsAvailable) {
                        $(".textbox-units-prorate").parents("span.ux-input").addClass("input-error");
                        $(".textbox-units-prorate").prev().removeClass("error-hidden");
                    } else {
                        $(".textbox-units-prorate").parents("span.ux-input").removeClass("input-error");
                        $(".textbox-units-prorate").prev().addClass("error-hidden");
                    }
                });

                //Calculate First Time Table
                $("tbody tr", $e.tbl).each(function () {
                    calc.update.setValuesToZero($(this));
                });

                $(".textbox-projected-sales-price", $e.tbl).blur(function () {
                    var salesPrice = $(".textbox-projected-sales-price").val();
                    if (salesPrice >= 0) {
                        $(".textbox-projected-sales-price").parents("span.ux-input").removeClass("input-error");
                        $(".textbox-projected-sales-price").prev().addClass("error-hidden");
                        $("tbody tr", $e.tbl).each(function () {
                            calc.update.rowCalculations($(this));
                        });
                    } else {
                        $(".textbox-projected-sales-price").parents("span.ux-input").addClass("input-error");
                        $(".textbox-projected-sales-price").prev().removeClass("error-hidden");
                    }
                });

                $("tbody tr .input-numeric input", $e.tbl).blur(function () {
                    var unitsAvailable = Math.round($(this).parents("tr").find($e.available).text());
                    var unitsSold = $h.removeComma($(this).parents("tr").find($e.sold).text());

                    if (unitsAvailable >= unitsSold) {
                        $(this).parents("span.ux-input").removeClass("input-error");
                        $(this).prev().addClass("error-hidden");
                        calc.update.rowCalculations($(this).parents("tr"));
                        $(this).val($h.addComma($(this).val()));
                    } else {
                        $(this).parents("tr").find($e.sold).prev().removeClass("error-hidden");
                    }
                });

                $("tbody .input-numeric input", $e.tbl).focus(function (i) {
                    $(this).val($h.removeComma($(this).val()));
                });

                $("#sell-all-units").on("click", function () {
                    $("tbody tr", $e.tbl).each(function () {
                        $(this).find($e.sold).text($(this).find($e.available).text());
                        calc.update.rowCalculations($(this));
                    });
                });

                $("#prorate").on("click", function () {
                    var totalUnitsAvailable = 0;
                    var prorateUnits = $(".textbox-units-prorate").val();
                    $("tbody tr", $e.tbl).each(function () {
                        totalUnitsAvailable += parseFloat($(this).find($e.available).text());
                    });
                    $("tbody tr", $e.tbl).each(function () {
                        var weight = $(this).find($e.available).text() / totalUnitsAvailable;
                        var units = weight * prorateUnits;
                        $(this).find($e.sold).text(units.toFixed(4));
                        calc.update.rowCalculations($(this));
                    });
                });

                $("#reset-units").on("click", function () {
                    $(".textbox-projected-sales-price").val($(".textbox-projected-sales-price").data("stock-quote"));
                    $("tbody tr", $e.tbl).each(function () {
                        $(this).find($e.purchaseAmount).val($(this).data("purchase-amount"));
                        $(".textbox-units-prorate").parents("span.ux-input").removeClass("input-error");
                        calc.update.setValuesToZero($(this));
                    });
                });
            },
            jurisdictionSelection: function (type) {
                $(' #0.jurisdiction-checkbox').attr('checked', true);
                $('#jurisdiction-selection').on('click', '.jurisdiction-select-all', function () {
                    if ($(this).prop('checked')) {
                        $('.jurisdiction-checkbox').each(function () {
                            $(this).prop('checked', true);
                        });
                    }
                });
                $('#jurisdiction-selection').on('click', '.jurisdiction-checkbox', function () {
                    if (!$(this).prop('checked')) {
                        $('.jurisdiction-select-all').prop('checked', false);
                    }
                });
            },
            copyGainLoss: function (TaxID) {
                var output = "";

                //table header
                output += "Tax ID\tTicker\t";
                $("div[id='GainLossCalculator'] thead td").each(function () {
                    output += $(this).html() + "\t";
                });
                output += "\n";

                //table body
                var id = TaxID.toString();
                $("div[id='GainLossCalculator'] tbody tr").each(function () {
                    output += "*****" + id + "\t";
                    output += $("#ticker").html() + "\t";
                    $(this).each(function () {
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-units-available']").html()) + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-acquisition-date']").html()) + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-units-sold']").html()) + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-sales-proceeds']").html()) + "\t";
                        output += $(this).find("input[class='textbox-purchase-amount']").val() + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-cumulative-adjustment-to-basis']").html()) + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-total-gain-loss']").html()) + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-ordinary-gain']").html()) + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-capital-gain-loss']").html()) + "\t";
                        output += common.ui.helper.trim($(this).find("span[class='ux-output output-amt-adjustment']").html()) + "\t";
                    });
                    output += "\n";
                });

                var target = $("textarea[id='textbox-copy-data']");
                target.val(output);
                target.focus();
                target.select();
                try {
                    // copy text
                    document.execCommand('copy');
                    $("textarea[id='textbox-copy-data']").blur();
                }
                catch (err) {
                    //error
                }
            },
            confirmPaperless: function () {
                $('.ui-dialog .ui-dialog-buttonpane').hide();
                $(".ui-dialog-titlebar-close").hide();

                $('.btn.btn-primary.ux-action.paperless-confirm').on('click', function () {
                    $(".ui-dialog-titlebar-close").show();
                    $('.ui-dialog .ui-dialog-buttonpane').show();
                    $('.ux-dialog').dialog('close');
                });
            },
            mfaVerifyCode: function (changeDeliveryUrl, resendCodeUrl, isManage, isRecaptchaDisabled = false) {
                $('.row-mfa-code input#Code').focus();
                var deliveryMethodID = 0;

                function linkBackAction() {
                    $('#DeliveryMethodID').val(deliveryMethodID);

                    function mfaVerifyOtherType() {
                        $.ajax({
                            type: "GET",
                            url: changeDeliveryUrl,
                            cache: false,
                            data: $('form#mfa-authentication-verify').serialize(),
                            beforeSend: function () {
                                if (isManage) {
                                    common.ui.helper.showConfirmSubmitAnimation();
                                } else {
                                    common.ui.helper.showDialogSubmitAnimation();
                                }
                            },
                            success: function (result) {
                                if (!isRecaptchaDisabled) {
                                    common.ui.init.resetRecaptcha();
                                }
                                if (result) {
                                    if (isManage) {
                                        $("#TwoStepScreen").html(result);
                                        common.ui.helper.hideConfirmSubmitAnimation();
                                    } else {
                                        $(".ui-dialog .ui-dialog-content").html(result);
                                    }
                                }
                                else {
                                    location.reload();
                                }
                                return false;
                            },
                            error: function () {
                                if (!isRecaptchaDisabled) {
                                    common.ui.init.resetRecaptcha();
                                }
                                location.reload();
                            }
                        });
                        return false;
                    }
                    if (!isRecaptchaDisabled && _mlp.recaptchaEnabled) {
                        window.onRecaptchaFormSubmit = function () {
                            $('#mfa-authentication-verify').append("<input name='g-recaptcha-response' value='" + grecaptcha.getResponse() + "' type='hidden'/>");
                            mfaVerifyOtherType();
                            grecaptcha.reset();
                        };
                        grecaptcha.execute();
                    }
                    else {
                        mfaVerifyOtherType();
                    }
                    event.preventDefault();
                    return false;
                }

                $('.ux-action.link-back-phone').click(function () {
                    deliveryMethodID = 3;
                    linkBackAction();
                });

                $('.ux-action.link-back-sms').click(function () {
                    deliveryMethodID = 2;
                    linkBackAction();
                });

                $('.ux-action.link-back-email').click(function () {
                    deliveryMethodID = 1;
                    linkBackAction();
                });

                $('.ux-action.link-resend').click(function () {
                    function resend(url) {
                        $.ajax({
                            url: url,
                            cache: false,
                            beforeSend: function () {
                                if (isManage) {
                                    common.ui.helper.showConfirmSubmitAnimation();
                                } else {
                                    common.ui.helper.showDialogSubmitAnimation();
                                }
                            },
                            success: function (result) {
                                if (result) {
                                    if (isManage) {
                                        $("#TwoStepScreen").html(result);
                                        common.ui.helper.hideConfirmSubmitAnimation();
                                    } else {
                                        $(".ui-dialog .ui-dialog-content").html(result);
                                    }
                                }
                                else {
                                    location.reload();
                                }
                                return false;
                            },
                            error: function () {
                            }
                        });
                    }

                    setTimeout(resend(resendCodeUrl), 2000);

                    return false;
                });
            },
            generalMFVerifyCode: function (changeDeliveryUrl, resendCodeUrl) {
                var deliveryMethodID = 0;

                function linkBackAction() {
                    $('#DeliveryMethodID').val(deliveryMethodID);

                    function mfaVerifyOtherType() {
                        $.ajax({
                            type: "GET",
                            url: changeDeliveryUrl,
                            cache: false,
                            data: $('form#mfa-authentication-verify').serialize(),
                            beforeSend: function () {
                                common.ui.helper.showDialogSubmitAnimation();
                            },
                            success: function (result) {
                                common.ui.init.resetRecaptcha();
                                if (result) {
                                    $(".ui-dialog .ui-dialog-content").html(result);
                                }
                                else {
                                    location.reload();
                                }
                                return false;
                            },
                            error: function () {
                                common.ui.init.resetRecaptcha();
                                location.reload();
                            }
                        });
                        return false;
                    }

                    if (_mlp.recaptchaEnabled) {
                        window.onRecaptchaFormSubmit = function () {
                            $('#mfa-authentication-verify').append("<input name='g-recaptcha-response' value='" + grecaptcha.getResponse() + "' type='hidden'/>");
                            mfaVerifyOtherType();
                            grecaptcha.reset();
                        };
                        grecaptcha.execute();
                    }
                    else {
                        mfaVerifyOtherType();
                    }
                    event.preventDefault();
                    return false;
                }

                $('.ux-action.link-back-phone').click(function () {
                    deliveryMethodID = 3;
                    linkBackAction();
                });

                $('.ux-action.link-back-sms').click(function () {
                    deliveryMethodID = 2;
                    linkBackAction();
                });

                $('.ux-action.link-back-email').click(function () {
                    deliveryMethodID = 1;
                    linkBackAction();
                });

                $('.ux-action.link-resend').click(function () {
                    function resend(url) {
                        $.ajax({
                            url: url,
                            cache: false,
                            beforeSend: function () {
                                common.ui.helper.showDialogSubmitAnimation();
                            },
                            success: function (result) {
                                if (result) {
                                    $(".ui-dialog .ui-dialog-content").html(result);
                                }
                                else {
                                    location.reload();
                                }
                                return false;
                            },
                            error: function () {
                            }
                        });
                    }

                    setTimeout(resend(resendCodeUrl), 2000);

                    return false;
                });
            },
            requestTPSIdentityVerification: function () {
                var viewNonUnitHolderUserInformation = "div[data-tab-content='viewNonUnitHolderUserInformation']",
                    editNonUnitHolderUserInformation = "div[data-tab-content='editNonUnitHolderUserInformation']",
                    confirmButton = ".ui-dialog .ui-dialog-buttonpane";

                //Edit Buttons
                $('body').off('click', ".btn-editOwnershipGeneral").on('click', ".btn-editUserInformation", function (e) {
                    $(editNonUnitHolderUserInformation).show();
                    $(viewNonUnitHolderUserInformation).hide();
                    $(confirmButton).css('visibility', 'hidden');
                    e.preventDefault();
                });

                // Cancel Buttons
                $('body').off('click', ".btn-cancelUserInformation").on('click', ".btn-cancelUserInformation", function (e) {
                    $(editNonUnitHolderUserInformation).hide();
                    $(viewNonUnitHolderUserInformation).show();
                    $(confirmButton).css('visibility', 'visible');
                    e.preventDefault();
                });
            },
            mfaSendCode: function () {
                $('.switch-radio input').on("change", function () {
                    changeConfirmMFButton($('.switch-radio input:checked').val());
                });

                changeConfirmMFButton($('.switch-radio input:checked').val());

                function changeConfirmMFButton(deliveryMethod) {
                    switch (deliveryMethod) {
                        case "1,", "2":
                            $('#mfa-confirm-button').html("Send");
                            break;
                        case "3":
                            $('#mfa-confirm-button').html("Call");
                            break;
                    }
                }
            },
            unsubscribe: function (displayBranding) {
                $(document).ready(function () {
                    if (displayBranding === 'False') {
                        $('#ux-logo').remove();
                        $('#ux-app-footer').remove();
                    }
                });
            },
            k1AssociationRequestDecision: function (isApproved, isDenied) {
                $(document).ready(function () {
                    if (isApproved === 'True') {
                        $('#association-request-decision-content').css('color', '#009933');
                    } else if (isDenied === 'True') {
                        $('#association-request-decision-content').css('color', '#a32020');
                    }
                });
            },
            recaptcha: function (formSelector, buttonSelector) {
                if (_mlp.recaptchaEnabled) {
                    window.onRecaptchaFormSubmit = function () {
                        $(formSelector).submit();
                    };

                    $(buttonSelector).click(function () { grecaptcha.execute(); });

                    $(document).ready(function () {

                        $(formSelector).on("keypress keydown keyup", function (e) {
                            if (e.keyCode === 13) {
                                e.preventDefault();
                                return false;
                            }
                        });
                    });
                }
                else {
                    $(buttonSelector).click(function () { $(formSelector).submit(); });
                }
            },
            ajaxLoginRecaptcha: function (formSelector, submitFormFunction) {
                $(formSelector).submit(function (event) {
                    if (_mlp.recaptchaEnabled) {
                        window.onRecaptchaFormSubmit = function () {
                            submitFormFunction();
                        };
                        grecaptcha.execute();
                    }
                    else {
                        submitFormFunction();
                    }
                    event.preventDefault();
                    return false;
                });
            },
            ajaxRecaptcha: function (formSelector, submitFormFunction) {
                $(formSelector).submit(function (event) {
                    if (_mlp.recaptchaEnabled) {
                        window.onRecaptchaFormSubmit = function () {
                            $(formSelector).append("<input name='g-recaptcha-response' value='" + grecaptcha.getResponse() + "' type='hidden'/>");
                            submitFormFunction();
                            grecaptcha.reset();
                        };
                        grecaptcha.execute();
                    }
                    else {
                        submitFormFunction();
                    }
                    event.preventDefault();
                    return false;
                });
            },
            resetRecaptcha: function () {
                if (_mlp.recaptchaEnabled) {
                    grecaptcha.reset();
                }
            },
            identityVerificationQuestionnaire: function (currentSlide) {
                $(".kba-carousel-skip").on('click', function () {
                    $("#kba-carousel-skip").val(true);
                    $("#identity-verification-form").submit();
                });
                $(".kba-carousel-submit").on('click', function () {
                    $("#kba-carousel-skip").val(false);
                    $("#identity-verification-form").submit();
                });

                const mySiema = new Siema({
                    selector: '.kba-carousel',
                    draggable: false
                });

                function changeSlide() {
                    var currentSlide = mySiema.currentSlide + 1;
                    $(".kba-status-indicator").attr("data-status-active", currentSlide);

                    if (mySiema.currentSlide === 0) {
                        $(".kba-carousel-skip").show();
                        $(".kba-carousel-prev").hide();
                        $(".kba-carousel-next").show();
                        $(".kba-carousel-submit").hide();
                    }
                    else if (mySiema.currentSlide === mySiema.innerElements.length - 1) {
                        $(".kba-carousel-skip").hide();
                        $(".kba-carousel-prev").show();
                        $(".kba-carousel-next").hide();

                        if ($("div[data-slide-id='" + currentSlide + "' ] input[name='Question" + currentSlide + "Answer']:checked").val()) {
                            $(".kba-carousel-submit").show();
                        }
                    }
                    else {
                        $(".kba-carousel-skip").hide();
                        $(".kba-carousel-prev").show();
                        $(".kba-carousel-next").show();
                        $(".kba-carousel-submit").hide();
                    }
                }

                $("div[data-slide-id='" + mySiema.innerElements.length + "' ] input[name='Question" + mySiema.innerElements.length + "Answer']").change(function () {
                    if (this.checked) {
                        $(".kba-carousel-submit").show();
                    }
                });

                function carouselNext() {
                    var currentSlide = mySiema.currentSlide + 1;

                    if ($("div[data-slide-id='" + currentSlide + "' ] input[name='Question" + currentSlide + "Answer']:checked").val()) {
                        $("div[data-slide-id='" + currentSlide + "'] .kba-validations").hide();
                        mySiema.next();
                        changeSlide();
                    }
                    else {
                        $("div[data-slide-id='" + currentSlide + "'] .kba-validations").slideDown();
                    }
                }

                function carouselPrev() {
                    mySiema.prev();
                    changeSlide();
                }

                $('.kba-carousel-prev').click(function () {
                    carouselPrev();
                });
                $('.kba-carousel-next').click(function () {
                    carouselNext();
                });

                mySiema.goTo(currentSlide);
                changeSlide();
            },
            identityVerificationQuestionnaireAddK1: function (currentSlide) {
                $(".kba-carousel-skip").on('click', function () {
                    $("#kba-carousel-skip").val(true);
                    $("#addK1Single").submit();
                });

                const mySiema = new Siema({
                    //selector likely has to be unique. If set to .kba-carousel, it might select another element named .kba-carousel-confirm, for example
                    selector: '.kba-carousel-add-k1',
                    draggable: false
                });

                function changeSlide() {
                    var currentSlide = mySiema.currentSlide + 1;
                    $(".kba-status-indicator").attr("data-status-active", currentSlide);

                    if (mySiema.currentSlide === 0) {
                        $(".kba-carousel-skip").show();
                        $(".kba-carousel-prev").hide();
                        $(".kba-carousel-next").show();
                        $(".verify-identity-submit").hide();
                    }
                    else if (mySiema.currentSlide === mySiema.innerElements.length - 1) {
                        $(".kba-carousel-skip").hide();
                        $(".kba-carousel-prev").show();
                        $(".kba-carousel-next").hide();

                        if ($("div[data-slide-id='" + currentSlide + "' ] input[name='Question" + currentSlide + "Answer']:checked").val()) {
                            $(".verify-identity-submit").show();
                        }
                    }
                    else {
                        $(".kba-carousel-skip").hide();
                        $(".kba-carousel-prev").show();
                        $(".kba-carousel-next").show();
                        $(".verify-identity-submit").hide();
                    }
                }

                $("div[data-slide-id='" + mySiema.innerElements.length + "' ] input[name='Question" + mySiema.innerElements.length + "Answer']").change(function () {
                    if (this.checked) {
                        $(".verify-identity-submit").show();
                    }
                });

                function carouselNext() {
                    var currentSlide = mySiema.currentSlide + 1;

                    if ($("div[data-slide-id='" + currentSlide + "' ] input[name='Question" + currentSlide + "Answer']:checked").val()) {
                        $("div[data-slide-id='" + currentSlide + "'] .kba-validations").hide();
                        mySiema.next();
                        changeSlide();
                    }
                    else {
                        $("div[data-slide-id='" + currentSlide + "'] .kba-validations").slideDown();
                    }
                }

                function carouselPrev() {
                    mySiema.prev();
                    changeSlide();
                }

                $('.kba-carousel-prev').click(function () {
                    carouselPrev();
                });
                $('.kba-carousel-next').click(function () {
                    carouselNext();
                });

                mySiema.goTo(currentSlide);
                changeSlide();
            },
            identityVerificationResult: function (isSuccess) {
                $(".kba-result-close").click(function () {
                    $('.ux-dialog').dialog('close');
                });
                $(".ux-dialog").dialog({ width: 600, height: "auto", position: { my: "center", at: "center", of: window } });

                if (isSuccess) {
                    $('.ux-dialog').on('click', ".ux-action.action-edd", function () {
                        common.ui.helper.showHideToggle($('.ux-dialog .content-confirm-edd'), $('.action-modal-content.modal-content-active'));
                        $(".ux-dialog").dialog({ width: 760, height: 450, position: { my: "center", at: "center", of: window } });
                        $('.ui-dialog .ui-dialog-buttonpane').hide();
                    });
                    $('.ux-dialog').on('click', ".ux-action.action-edd-close", function () {
                        common.ui.helper.showHideToggle($('.action-modal-content.modal-content-active'), $('.ux-dialog .content-confirm-edd'));
                        $(".ux-dialog").dialog({ width: 600, height: "auto", position: { my: "center", at: "center", of: window } });
                        $('.ui-dialog .ui-dialog-buttonpane').show();
                    });
                }
            },
            identityVerificationPrompt: function () {
                $(".ui-dialog-title").html("Identity Verification");
                $('.ux-dialog').on('click', ".box-type-row-owner", function () {
                    $("#proceed-form-input").val(true);
                });
                $('.ux-dialog').on('click', ".box-type-row-other", function () {
                    $("#proceed-form-input").val(false);
                });
            },
            newUserPizzaTracker: function (currentSlide, isTwilioEnabled, isPartnership, lookupTPSUserTypeDictionary) {
                var mySiema = new Siema({
                    selector: '.kba-carousel',
                    draggable: false,
                    duration: 0
                });

                function changeSlide(currentSlide) {
                    $(".kba-status-indicator").attr("data-status-active", currentSlide + 1);

                    if (currentSlide === 0) {
                        $(".kba-carousel-skip").show();
                        $(".kba-carousel-prev").hide();
                        $(".kba-carousel-next").show();
                    }
                    else if (currentSlide === 1) {
                        $(".kba-carousel-skip").show();
                        $(".kba-carousel-prev").show();
                        $(".kba-carousel-next").show();
                    }
                    else if (currentSlide === 2) {
                        $(".kba-carousel-skip").hide();
                        $(".kba-carousel-prev").hide();
                        $(".kba-carousel-next").show();
                    }
                    else if (currentSlide === 3) {
                        $(".kba-carousel-prev").hide();
                        $(".kba-carousel-next").hide();
                        $(".kba-carousel-skip").hide();
                    }
                }

                function carouselNext() {
                    changeSlide(mySiema.currentSlide + 1);
                    mySiema.next();
                }

                function carouselPrev() {
                    changeSlide(mySiema.currentSlide - 1);
                    $('.kba-carousel-next').removeClass("disabled-button");
                    mySiema.prev();
                }

                function carouselGoTo(slide) {
                    changeSlide(slide);
                    mySiema.goTo(slide);
                }

                $('.kba-carousel-prev').click(function () {
                    if (mySiema.currentSlide === 1) {
                        $(".confirm-user-type-switch").show();
                        $("#confirm-secondary-icon-0").hide();
                        $("#confirm-secondary-icon-1").hide();
                        $("#confirm-primary-icon-1").addClass("confirm-grey-icon");
                        $("#confirm-animated-icon-0").addClass("animated-confirm-status");
                        $("#confirm-animated-icon-1").removeClass("animated-confirm-status");
                        $("#confirm-animated-icon-1").removeClass("confirm-non-grey-border");
                        $("#confirm-animated-icon-1").addClass("confirm-grey-border");
                        if ($(".cxp-active").children().first().data("user-type-id") > 1) {
                            $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                            $(".content-confirm-newux").addClass("select-user-type-2");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-user-type-2");
                        } else {
                            $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                            $(".content-confirm-newux").addClass("select-user-type-1");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-user-type-1");
                        }

                        if (isPartnership)
                        {
                            if (isTwilioEnabled)
                            {
                                $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                $("#kba-status-indicator-confirm-border").addClass("section-0-twilio-partnership");
                            }
                            else
                            {
                                $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                $("#kba-status-indicator-confirm-border").addClass("section-0");
                            }
                        }
                        else
                        {
                            if (isTwilioEnabled)
                            {
                                $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                $("#kba-status-indicator-confirm-border").addClass("section-0");
                            }
                            else
                            {
                                $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                $("#kba-status-indicator-confirm-border").addClass("section-0-non-twilio-non-partnership");
                            }
                        }
                    }
                    else if (mySiema.currentSlide === 2 ) {
                        $("#confirm-primary-icon-2").addClass("confirm-grey-icon");
                        $("#confirm-animated-icon-1").addClass("animated-confirm-status");
                        $("#confirm-animated-icon-1").removeClass("confirm-grey-border");
                        $("#confirm-animated-icon-2").removeClass("animated-confirm-status");
                        $("#confirm-animated-icon-2").addClass("confirm-grey-border");
                        if (isPartnership)
                        {
                            if (isTwilioEnabled)
                            {
                                $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                $("#kba-status-indicator-confirm-border").addClass("section-1-twilio-partnership");
                            }
                            else
                            {
                                $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                $("#kba-status-indicator-confirm-border").addClass("section-1");
                            }
                        }
                        else
                        {
                            $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                            $("#kba-status-indicator-confirm-border").addClass("section-1");
                        }

                        if ($(".cxp-active").children().first().data("user-type-id") > 1) {
                            $("#UserInfoCompanyUserEntry").show();
                        } else {
                            $("#UserInfoCompanyUserEntry").hide();
                        }
                        if ($(".cxp-active").children().first().data("user-type-id") > 1) {
                            $("#UserInfoCompanyUserEntry").show();
                            $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                            $(".content-confirm-newux").addClass("select-info-2");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-info-2");
                        } else {
                            $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                            $(".content-confirm-newux").addClass("select-info-1");
                            $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                            $(".kba-carousel").addClass("height-info-1");
                            $("#UserInfoCompanyUserEntry").hide();
                        }
                    }

                    carouselPrev();
                });

                $('.kba-carousel-next').click(function () {
                    var currentSlide = mySiema.currentSlide;
                    if (currentSlide === 2) {
                        $('.ux-dialog form#mfa-authentication-verify').submit();
                    }
                    else if (currentSlide === 1) {
                        $(".ux-dialog form#authentication-confirm").submit();
                    }
                    else if (currentSlide === 0) {
                        if ($("#confirmUserType").prop("checked")) {
                            $('#select-user-type-partial .box-type-row-confirm-error').hide();
                            $("#confirm-primary-icon-1").removeClass("confirm-grey-icon");
                            $("#confirm-animated-icon-1").addClass("animated-confirm-status");
                            $("#confirm-animated-icon-0").removeClass("animated-confirm-status");
                            $("#confirm-animated-icon-0").addClass("confirm-non-grey-border");
                            $("#confirm-animated-icon-1").removeClass("confirm-grey-border");

                            if (isPartnership) {
                                if (isTwilioEnabled) {
                                    $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                    $("#kba-status-indicator-confirm-border").addClass("section-1-twilio-partnership");
                                } else {
                                    $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                    $("#kba-status-indicator-confirm-border").addClass("section-1");
                                }
                            } else {
                                if (isTwilioEnabled) {
                                    $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                    $("#kba-status-indicator-confirm-border").addClass("section-1");

                                } else {
                                    $("#kba-status-indicator-confirm-border").attr('class', function (i, val) { return val.replace(/(^|\s)section\S+/g, ''); });
                                    $("#kba-status-indicator-confirm-border").addClass("section-1-non-twilio-non-partnership");
                                }
                            }

                            if ($(".cxp-active").children().first().data("user-type-id") > 1) {
                                $("#confirm-secondary-icon-0").show();
                                $("#confirm-secondary-icon-1").show();
                                $("#UserInfoCompanyUserEntry").show();
                                $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                                $(".content-confirm-newux").addClass("select-info-2");
                                $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                                $(".kba-carousel").addClass("height-info-2");
                            } else {
                                $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                                $(".content-confirm-newux").addClass("select-info-1");
                                $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                                $(".kba-carousel").addClass("height-info-1");
                                $("#UserInfoCompanyUserEntry").hide();
                            }

                            var userTypeID = $(".cxp-active").children().first().data("user-type-id");
                            switch (userTypeID) {
                                case 1: $(".confirm-subheader").text(lookupTPSUserTypeDictionary["1"]);
                                    break;
                                case 2: $(".confirm-subheader").text(lookupTPSUserTypeDictionary["2"]);
                                    break;
                                case 3: $(".confirm-subheader").text(lookupTPSUserTypeDictionary["3"]);
                                    break;
                                case 4: $(".confirm-subheader").text(lookupTPSUserTypeDictionary["4"]);
                                    break;
                                case 5: $(".confirm-subheader").text(lookupTPSUserTypeDictionary["5"]);
                                    break;
                                case 6: $(".confirm-subheader").text(lookupTPSUserTypeDictionary["6"]);
                                    break;
                            }

                            carouselNext();
                        } else {
                            if ($(".cxp-active").children().first().data("user-type-id") > 1) {
                                $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                                $(".content-confirm-newux").addClass("select-user-type-2-error");
                                $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                                $(".kba-carousel").addClass("height-user-type-2-error");
                            } else {
                                $(".content-confirm-newux").attr('class', function (i, val) { return val.replace(/(^|\s)select\S+/g, ''); });
                                $(".content-confirm-newux").addClass("select-user-type-1-error");
                                $(".kba-carousel").attr('class', function (i, val) { return val.replace(/(^|\s)height\S+/g, ''); });
                                $(".kba-carousel").addClass("height-user-type-1-error");
                            }

                           $('#select-user-type-partial .box-type-row-confirm-error').show();
                        }
                    }
                });
                
                if (currentSlide === 0) {
                    $(".kba-carousel-skip").show();
                    $(".kba-carousel-prev").hide();
                    $(".kba-carousel-next").show();
                }
                else if (currentSlide === 1) {
                    $(".kba-carousel-skip").show();
                    $(".kba-carousel-prev").show();
                    $(".kba-carousel-next").show();
                }
                else if (currentSlide === 2) {
                    $(".kba-carousel-skip").hide();
                    $(".kba-carousel-prev").hide();
                    $(".kba-carousel-next").show();
                }
                else if (currentSlide === 3) {
                    $(".kba-carousel-prev").hide();
                    $(".kba-carousel-next").hide();
                    $(".kba-carousel-skip").hide();
                }
                $('.ui-dialog-buttonset').addClass("confirm-button");
                
                //confirm-button class is break buttonpane
                if ($('.ui-dialog-buttonpane #phone-number-section').length > 0) {
                    $('.ui-dialog-buttonset').removeClass("confirm-button");
                }

                carouselGoTo(currentSlide);
            }
        },
            dialog: function (_ele) {
            function showLoading() {
                $('#modalDialogJurisdictionSelection').html("");
                var html = '';

                html += '<div style="text-align: center; margin-top: 60px;">Generating K-1s</div><div class="ux-loading" style=""><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div><div style="text-align: center">Please wait. This make take up to a few minutes.</div>';
                $('#modalDialogJurisdictionSelection').html(html);
            }

            $(".ux-dialog").html('<div class="ux-loading"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div>');

            var setDialogButtons = {};

            var $e = $(_ele),
                $d = {
                    "type": null,
                    "title": null,
                    "display": null,
                    "url": null,
                    "template": null,
                    "width": null,
                    "height": null,
                    "unitholder": null,
                    "closeDisabled": null,
                    "downloadUrl": null,
                    "phoneNumber": null
                };

            if ($e.data("action-type")) {
                $d.type = $e.data("action-type");
            }
            if ($e.data("title")) {
                $d.title = $e.data("title");
            }
            if ($e.data("display")) {
                $d.display = $e.data("display");
            }
            if ($e.data("action-url")) {
                $d.url = $e.data("action-url");
            }
            if ($e.data("action-template")) {
                $d.template = $e.data("action-template");
            }
            if ($e.data("display-width")) {
                $d.width = $e.data("display-width");
            } else {
                $d.width = 600;
            }
            if ($e.data("display-height")) {
                $d.height = $e.data("display-height");
            } else {
                $d.height = "auto";
            }
            //Refactor if No Longer Needed
            if ($e.data("unitholder")) {
                $d.unitholder = $e.data("unitholder");
            } else {
                $d.unitholder = false;
            }
            if ($e.data("close-disabled")) {
                $d.closeDisabled = $e.data("close-disabled");
            } else {
                $d.closeDisabled = false;
            }
            if ($e.data("action-download-url")) {
                $d.downloadUrl = $e.data("action-download-url");
            }
            if ($e.data("phone-number")) {
                $d.phoneNumber = $e.data("phone-number");
            }

            $('.ux-dialog').dialog({
                height: $d.height,
                width: $d.width,
                modal: true,
                title: $d.title,
                closeOnEscape: !$d.closeDisabled,
                open: function (ui) {
                    if ($d.closeDisabled === true) {
                        $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
                    } else if ($d.closeDisabled === false) {
                        $(".ui-dialog-titlebar-close", ui.dialog | ui).show();
                    }
                }
            });

                if ($d.url !== null) {
                $.ajax({
                    url: $d.url,
                    cache: false,
                    dataType: "html",
                    success: function (data) {
                        if (!data) {
                            location.reload();
                        }
                        else {
                            setDialogButtons = {};

                            $(".ux-dialog").html(data);

                            var isEmpty = true;

                            if ($(".ux-dialog").find("form").length > 0) {
                                isEmpty = false;
                            }

                            if ($d.display === "add" || $d.display === "edit") {

                                if (!isEmpty) {
                                    setDialogButtons["Cancel"] = {
                                        text: "Cancel",
                                        class: "btn btn-primary outline",
                                        click: function () {
                                            $(this).dialog("close");
                                        }
                                    };
                                    setDialogButtons["Save"] = {
                                        text: "Save",
                                        class: "btn btn-primary",
                                        click: function () {
                                            $(this).find('.modal-content-active form').trigger('submit');
                                        }
                                    };
                                } else {
                                    setDialogButtons["Close"] = {
                                        text: "Close",
                                        class: "btn btn-primary outline",
                                        click: function () {
                                            $(this).dialog("close");
                                        }
                                    };
                                }
                            } else if ($d.display === "confirm") {
                                var isConfirmEmail = $(".ux-dialog .content-confirm-email").length;
                                var isConfirmDisclaimer = $(".ux-dialog #confirm-disclaimer").prop("checked");
                                var isConfirmDisclaimerClass = isConfirmDisclaimer ? "btn-confirm-active" : "btn-confirm-inactive";
                                
                                if (isConfirmEmail < 1) {
                                    setDialogButtons["confirm"] = {
                                        text: "Confirm",
                                        class: "btn btn-primary " + "btn-confirm " + isConfirmDisclaimerClass,
                                        click: function () {
                                            $(this).find('.modal-content-active form').trigger('submit');
                                        }
                                    };
                                }
                            } else if ($d.display === "turbotax") {
                                var isErrorModal = $(".ux-dialog #errorModal").length;
                                if (isErrorModal <= 0) {
                                    setDialogButtons["Download"] = {
                                        text: "Download",
                                        class: "btn btn-primary",
                                        click: function () {
                                            window.location = $d.downloadUrl;
                                        }
                                    };
                                }
                                setDialogButtons["Close"] = {
                                    text: "Close",
                                    class: "btn btn-primary outline",
                                    click: function () {
                                        $(this).dialog("close");
                                    }
                                };
                            } else if ($d.display === "k1") {
                                setDialogButtons["View"] = {
                                    text: "View",
                                    class: "btn btn-primary",
                                    click: function () {
                                        if ($(".jurisdiction-checkbox:checkbox:checked").length > 0) {
                                            showLoading();
                                            $("#jurisdiction-selection").toggle(false);
                                            var jurisdictionsList = '';
                                            $('.jurisdiction-checkbox').each(function () {
                                                if (this.checked) {
                                                    if (jurisdictionsList.length !== 0) {
                                                        jurisdictionsList += ',';
                                                    }
                                                    jurisdictionsList += $(this).attr('id');
                                                }
                                            });
                                            window.open($d.downloadUrl + "&jurisdictions=" + jurisdictionsList, "_blank");
                                            location.reload();
                                        }
                                        else {
                                            $(".jurisdiction-selection-error").toggle(true);
                                        }
                                    }
                                };
                                setDialogButtons["Cancel"] = {
                                    text: "Cancel",
                                    class: "btn btn-primary outline",
                                    click: function () {
                                        $(this).dialog("close");
                                    }
                                };
                            } else if ($d.display === "gainloss") {
                                setDialogButtons["Copy"] = {
                                    html: "<i class='fa fa-clipboard'></i>",
                                    style: "margin-right: 790px; background-color: #f3f3f3; color: #f3f3f3;",
                                    class: "copy",
                                    click: function () {
                                        common.ui.init.copyGainLoss($("#TaxId").val());
                                    }
                                };
                                setDialogButtons["Close"] = {
                                    text: "Close",
                                    class: "btn btn-primary outline",
                                    click: function () {
                                        $(this).dialog("close");
                                    }
                                };
                            } else if ($d.display === "delete") {
                                if (!isEmpty) {
                                    setDialogButtons["Delete"] = {
                                        text: "Remove",
                                        class: "btn btn-primary",
                                        click: function () {
                                            $(this).find('.modal-content-active form').trigger('submit');
                                        }
                                    };
                                    setDialogButtons["Cancel"] = {
                                        text: "Cancel",
                                        class: "btn btn-primary outline",
                                        click: function () {
                                            $(this).dialog("close");
                                        }
                                    };
                                }
                            } else if ($d.display === "associationlimitrequest") {
                                if (!isEmpty) {
                                    setDialogButtons["Confirm"] = {
                                        text: "Confirm",
                                        class: "btn btn-primary",
                                        click: function () {
                                            $(this).find('.modal-content-active form').trigger('submit');
                                        }
                                    };
                                    setDialogButtons["Cancel"] = {
                                        text: "Cancel",
                                        class: "btn btn-primary outline",
                                        click: function () {
                                            $(this).dialog("close");
                                        }
                                    };
                                }
                            }
                            else if ($d.display === "forcedPasswordChange") {
                                if (!isEmpty) {
                                    setDialogButtons["Save"] = {
                                        text: "Save",
                                        class: "btn btn-primary",
                                        click: function () {
                                            $(this).find('.modal-content-active form').trigger('submit');
                                        }
                                    };
                                }
                            }

                            $('.ux-dialog').dialog('option', 'buttons', setDialogButtons);
                            $('.ux-dialog').dialog('option', 'open', setDialogOpen());

                            timeout.extendSessionFromAjax();
                        }
                    }
                });
            } else {
                if ($d.template !== null) {
                    setDialogButtons = {};

                    $(".ux-dialog").html($.templates("#" + $d.template).render());

                    setDialogButtons["Close"] = {
                        text: "Close",
                        class: "btn btn-primary outline",
                        click: function () {
                            $(this).dialog("close");
                        }
                    };
                }
            }


            var setDialogOpen = function () {
                $('.ui-dialog-buttonpane').find('button').removeClass('ui-state-hover ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only');
                $('.ui-dialog-buttonpane').find('button.outline').attr('outline', 'outline');
                $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'visible');
                if ($d.title === "Add K-1") {
                    if (!$('#phone-number-section').length) {
                        $('.ui-dialog-buttonpane').append('<div id="phone-number-section" class="ux-row phone-number-section-confirm" style="position: relative"><i class="fa fa-exclamation-circle" style="font-size: 2em; top: 14px; left: 20px; position: absolute;"></i><p style="position: absolute; left: 60px; top: 18px; line-height: 16px; color: grey">If you are having difficulty adding a K-1, please have your brokerage statement available and call <b>' + $d.phoneNumber + '</b></p></div>');
                    }
                } else if ($('#phone-number-section').length > 0) {
                    $('#phone-number-section').remove();
                }
            };

            $('.ux-dialog').dialog('option', 'buttons', setDialogButtons);
            $('.ux-dialog').dialog('option', 'open', setDialogOpen());
        },
        post: {  
            add: function (addSingleUrl, reloadAssociationUrl, fromConfirmModal, phoneNumber) {
                var setDialogOpenK1 = function () {
                    $('.ui-dialog-buttonpane').find('button').removeClass('ui-state-hover ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only');
                    $('.ui-dialog-buttonpane').find('button.outline').attr('outline', 'outline');
                    $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'visible');
                    if (!$('#phone-number-section').length) {
                        $('.ui-dialog-buttonpane').append('<div id="phone-number-section" class="ux-row phone-number-section-confirm" style="position: relative"><i class="fa fa-exclamation-circle" style="font-size: 2em; top: 14px; left: 20px; position: absolute;"></i><p style="position: absolute; left: 60px; top: 18px; line-height: 16px; color: grey">If you are having difficulty adding a K-1, please have your brokerage statement available and call <b>' + phoneNumber + '</b></p></div>');
                    }
                };
                $('.ux-dialog form#addK1Single').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: addSingleUrl,
                        data: $('.ux-dialog form#addK1Single').serialize(),
                        cache: false,
                        beforeSend: function () {
                            if (fromConfirmModal === "true") {
                            common.ui.helper.showConfirmSubmitAnimation();
                            }else{
                            common.ui.helper.showDialogSubmitAnimation();
                            }
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                if (fromConfirmModal === "true") {
                                    $("#add-k1-screen").html(result);
                                    setDialogButtons = {};
                                    setDialogButtons["Cancel"] = {
                                        text: "Cancel",
                                        class: "btn btn-primary outline",
                                        click: function () {
                                            $(this).dialog("close");
                                        }
                                    };
                                    setDialogButtons["Save"] = {
                                        text: "Save",
                                        class: "btn btn-primary disabled-button",
                                        click: function () {
                                            $(".btn-primary").addClass("disabled-button");
                                            $(this).find('#addK1Single').trigger('submit');
                                        }
                                    };

                                    $('.ux-dialog').dialog('option', 'buttons', setDialogButtons);
                                    $('.ux-dialog').dialog('option', 'open', setDialogOpenK1());
                                    common.ui.helper.hideConfirmSubmitAnimation();
                                
                                } else {
                                    $(".ui-dialog .ui-dialog-content").html(result);
                                    if ($('#modalValidations').html().indexOf("none") >= 0) {
                                        if ($('.content-confirm-paperless').length === 0) {
                                            $('.ux-dialog').dialog('close');
                                        }

                                        $.ajax({
                                            url: reloadAssociationUrl,
                                            cache: false,
                                            success: function (data) {
                                                $('#AssociationTable').html(data);
                                            }
                                        });
                                    }
                                }   

                            }
                            return false;
                        },
                        error: function () {
                            $(".btn-primary").removeClass("disabled-button");
                        }
                    });

                    return false;
                }
                );},
            requestTPSIdentityVerification: function (submitRequest, saveUserInformation) {
                $('.ux-dialog form#requestTPSIdentityVerification').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: submitRequest,
                        data: $('.ux-dialog form#requestTPSIdentityVerification').serialize(),
                        cache: false,
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                            $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'hidden');
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'hidden');
                            }
                            return false;
                        },
                        error: function () {

                        }
                    });
                    return false;
                });

                $('.ux-dialog .btn-saveUserInformation').on('click', function () {
                    $.ajax({
                        type: "POST",
                        url: saveUserInformation,
                        data: $('.ux-dialog form#requestTPSIdentityVerification').serialize(),
                        cache: false,
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);

                                if ($("div[data-tab-content='editNonUnitHolderUserInformation']").is(":visible")) {
                                    $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'hidden');
                                }
                                else {
                                    $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'visible');
                                }
                            }
                            return false;
                        },
                        error: function () {

                        }
                    });
                    return false;
                });
            },
            deleteAssociation: function (urlDelete, reloadAssociationUrl) {

                $("#deleteK1Single").submit(function () {
                    $.ajax({
                        type: "POST",
                        url: urlDelete,
                        cache: false,
                        data: $('#deleteK1Single').serialize(),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                $('.ux-dialog').dialog('close');
                                $.ajax({
                                    url: reloadAssociationUrl,
                                    cache: false,
                                    success: function (data) {
                                        $('#AssociationTable').html(data);
                                    }
                                });
                            }
                            return false;
                        },
                        error: function () {
                        }
                    });
                    return false;
                });

            },
            manageProfile: function (url, reloadAssociationUrl, getTpsUserInformationUrl, isPartnership) {
                /**
                 * Private method to refresh DisplayName in the UI
                 */
                function reloadDisplayName() {
                    $.ajax({
                        url: getTpsUserInformationUrl,
                        type: "GET",
                        cache: false,
                        success: function (result) {
                            if (result && result.success) {
                                var firstName = common.ui.helper.encodeInput(result.firstName);
                                var lastName = common.ui.helper.encodeInput(result.lastName);

                                if (!!firstName && !!lastName) {
                                    var fullName = document.createElement("b");
                                    fullName.innerHTML = `${firstName} ${lastName}`;

                                    $('#DisplayName').html(fullName);
                                }
                            }
                        }
                    });                    
                }

                /**
                 * manageProfile event handlers
                 */

                /**
                 * Controller: BaseController
                 * Method: ManageProfile
                 */
                $("#authentication-manage").submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        data: $('form#authentication-manage').serialize(),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (result) {
                                $(".ui-dialog .ui-dialog-content").html(result);

                                if (isPartnership && $("#VerifyPhoneNumber").val() === 'true') {

                                    $.ajax({
                                        url: reloadAssociationUrl,
                                        cache: false,
                                        async: false,
                                        success: function (data) {
                                            $('#AssociationTable').html(data);
                                        }
                                    });
                                }

                                if ($('#modalValidations').html()) {
                                    if ($('#modalValidations').html().indexOf("none") >= 0) {
                                        reloadDisplayName();
                                    }
                                }

                                return false;
                            } else {
                                reloadDisplayName();
                                $('.ux-dialog').dialog('close');
                            }
                        },
                        error: function () {
                        }

                    });
                    return false;
                });

                $(".kba-carousel-prev").click(function () {
                    $.ajax({
                        type: "GET",
                        url: url,
                        cache: false,
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (result) {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                if ($('#modalValidations')) {
                                    if ($('#modalValidations').html().indexOf("none") >= 0) {
                                        // Reloading DisplayName
                                        var first = common.ui.helper.encodeInput($('#FirstName').val());
                                        var last = common.ui.helper.encodeInput($('#LastName').val());

                                        var fullName = document.createElement("b");
                                        fullName.innerHTML = `${first} ${last}`;

                                        $('#DisplayName').html(fullName);
                                    }
                                }

                                return false;
                            } else {
                                location.reload();
                            }
                        },
                        error: function () {
                        }

                    });
                    return false;
                });

                $('.kba-carousel-next').click(function () {
                    $('.ux-dialog form#mfa-authentication-verify').submit();
                });
            },
            confirm: function (url, reloadAssociationUrl, isPartnership, isTwilioEnabled, phoneNumber) {
                function setDialogOpenK12 () {
                    $('.ui-dialog-buttonpane').find('button').removeClass('ui-state-hover ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only');
                    $('.ui-dialog-buttonpane').find('button.outline').attr('outline', 'outline');
                    $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'visible');
                    if (!$('#phone-number-section').length) {
                        $('.ui-dialog-buttonpane').append('<div id="phone-number-section" class="ux-row phone-number-section-confirm" style="position: relative"><i class="fa fa-exclamation-circle" style="font-size: 2em; top: 14px; left: 20px; position: absolute;"></i><p style="position: absolute; left: 60px; top: 18px; line-height: 16px; color: grey">If you are having difficulty adding a K-1, please have your brokerage statement available and call <b>' + phoneNumber + '</b></p></div>');
                    }
                }

                $("#authentication-confirm").submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        data: $('form#authentication-confirm').serialize(),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (result) {
                                $(".ui-dialog .ui-dialog-content").html(result);

                                if (isPartnership && !isTwilioEnabled && $("#ActiveSection").val() === "2") {
                                    setDialogButtons = {};
                                    setDialogButtons["Cancel"] = {
                                        text: "Cancel",
                                        class: "btn btn-primary outline",
                                        click: function () {
                                            $(this).dialog("close");
                                            //Launch Context Help Inital Experience
                                            if ($('tbody.tps-association-empty').length === 1) {
                                                mlp.helpers.firstTimeExperience('add');
                                            }
                                        }
                                    };
                                    setDialogButtons["Save"] = {
                                        text: "Save",
                                        class: "btn btn-primary",
                                        click: function () {
                                            $(this).find('#addK1Single').trigger('submit');
                                        }
                                    };

                                    $.ajax({
                                        url: reloadAssociationUrl,
                                        cache: false,
                                        async: false,
                                        success: function (data) {
                                            $('#AssociationTable').html(data);
                                        }
                                    });

                                    $('.ux-dialog').dialog('option', 'buttons', setDialogButtons);
                                    $('.ux-dialog').dialog('option', 'open', setDialogOpenK12());
                                    $(".ui-dialog-buttonset").removeClass('confirm-button');
                                }

                                if ($('#modalValidations').html()) {
                                    if ($('#modalValidations').html().indexOf("none") >= 0) {
                                        // Reloading DisplayName
                                        var first = common.ui.helper.encodeInput($('#FirstName').val());
                                        var last = common.ui.helper.encodeInput($('#LastName').val());

                                        var fullName = document.createElement("b");
                                        fullName.innerHTML = `${first} ${last}`;

                                        $('#DisplayName').html(fullName);
                                    }
                                }
                                return false;
                            } else {
                                location.reload();
                            }

                        },
                        error: function () {
                        }

                    });
                    return false;
                });
                                                
            },
            tandcSendEmail: function (url) {
                $('.ux-dialog form#tandc-send-email').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        async: true,
                        data: $('.ux-dialog form#tandc-send-email').serialize(),
                        success: function (data) { },
                        error: function () {

                        }
                    });

                    return false;
                });
            },
            mfaSendCode: function (url, isManage) {
                $('.ux-dialog form#mfa-authentication').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        data: $('.ux-dialog form#mfa-authentication').serialize(),
                        beforeSend: function () {
                            if (!isManage) {
                                common.ui.helper.showDialogSubmitAnimation();
                            } else {
                                common.ui.helper.showConfirmSubmitAnimation();
                            }
                        },
                        success: function (result) {
                            if (result) {
                                if (isManage) {
                                    $("#TwoStepScreen").html(result);
                                    common.ui.helper.hideConfirmSubmitAnimation();
                                } else {
                                    $(".ui-dialog .ui-dialog-content").html(result);
                                }
                            }
                            else {
                                location.reload();
                            }
                            return false;
                        },
                        error: function () {

                        }
                    });
                    return false;
                });
            },
            mfaVerifyCode: function (verifyUrl, isPartnership, isTwilioEnabled, phoneNumber, isManage, isRecaptchaDisabled = false) {
                function setDialogOpenK1() {
                    $('.ui-dialog-buttonpane').find('button').removeClass('ui-state-hover ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only');
                    $('.ui-dialog-buttonpane').find('button.outline').attr('outline', 'outline');
                    $(".ui-dialog .ui-dialog-buttonpane").css('visibility', 'visible');
                    if (!$('#phone-number-section').length) {
                        $('.ui-dialog-buttonpane').append('<div id="phone-number-section" class="ux-row phone-number-section-confirm" style="position: relative"><i class="fa fa-exclamation-circle" style="font-size: 2em; top: 14px; left: 20px; position: absolute;"></i><p style="position: absolute; left: 60px; top: 18px; line-height: 16px; color: grey">If you are having difficulty adding a K-1, please have your brokerage statement available and call <b>' + phoneNumber + '</b></p></div>');
                    }
                }
                function mfaVerifyFormSubmit() {
                    $.ajax({
                        type: "POST",
                        url: verifyUrl,
                        cache: false,
                        data: $('form#mfa-authentication-verify').serialize(),
                        beforeSend: function () {
                            if (isManage) {
                                common.ui.helper.showConfirmSubmitAnimation();
                            } else {
                                common.ui.helper.showDialogSubmitAnimation();
                            }
                        },
                        success: function (result) {
                            if (result) {
                                if (isManage) {
                                    $("#TwoStepScreen").html(result);
                                    common.ui.helper.hideConfirmSubmitAnimation();
                                } else {
                                    $(".ui-dialog .ui-dialog-content").html(result);
                                }
                                if (isPartnership && isTwilioEnabled && $("#ActiveSection").val() === "3") {
                                    setDialogButtons = {};
                                    setDialogButtons["Cancel"] = {
                                        text: "Cancel",
                                        class: "btn btn-primary outline",
                                        click: function () {
                                            $(this).dialog("close");
                                            //Launch Context Help Inital Experience
                                            if ($('tbody.tps-association-empty').length === 1) {
                                                mlp.helpers.firstTimeExperience('add');
                                            }
                                        }
                                    };
                                    setDialogButtons["Save"] = {
                                        text: "Save",
                                        class: "btn btn-primary",
                                        click: function () {
                                            $(this).find('#addK1Single').trigger('submit');
                                        }
                                    };

                                    $('.ux-dialog').dialog('option', 'buttons', setDialogButtons);
                                    $('.ux-dialog').dialog('option', 'open', setDialogOpenK1());
                                }                
                            }
                            else {
                                location.reload();
                            }
                            return false;
                        },
                        error: function () {
                            if (!isRecaptchaDisabled) {
                                common.ui.init.resetRecaptcha();
                            }
                            location.reload();
                        }
                    });
                    return false;
                }
                if (isRecaptchaDisabled) {
                    $('.ux-dialog form#mfa-authentication-verify').submit(function (event) {
                        mfaVerifyFormSubmit();
                        event.preventDefault();
                        return false;
                    });
                }
                else {
                    common.ui.init.ajaxRecaptcha('.ux-dialog form#mfa-authentication-verify', mfaVerifyFormSubmit);
                }
                
            },
            mfaTrustDevice: function (trustDeviceUrl) {
                $('.ux-dialog form#mfa-authentication').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: trustDeviceUrl,
                        cache: false,
                        data: $('.ux-dialog form#mfa-authentication').serialize(),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            location.reload();
                            return false;
                        },
                        error: function () {
                            location.reload();
                            return false;
                        }
                    });
                    return false;
                });
            },
            changePassword: function (url, forced) {
                $('.ux-dialog form#changePassword').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: $('.ux-dialog form#changePassword').serialize(),
                        cache: false,
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            $(".ui-dialog .ui-dialog-content").html(result);
                            if ($('#modalValidations').html().indexOf("none") >= 0) {
                                if (forced == "True") {
                                    location.reload();
                                }
                                else {
                                    $('.ux-dialog').dialog('close');
                                }
                            }
                            $('.ux-dialog .btn-primary').attr('disabled', 'disabled');
                            $('.ux-dialog .outline').removeAttr('disabled')
                            $('.ux-dialog #new-password').val("");
                            return false;
                        },
                        error: function () {
                            
                        }
                    });
                    return false;
                });
            },
            changeRequestOwnership: function (url, reloadOwnershipUrl, reloadAssociationUrl) {
                $('#editK1Ownership').one('submit', function (e) {
                    $(this).find('.btn-saveOwnershipGeneral').attr('disabled', 'disabled');
                });

                $('.ux-dialog form#editK1Ownership').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: $('.ux-dialog form#editK1Ownership').serialize(),
                        cache: false,
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                if ($('#NoLongerAssociates').val() === "True") {
                                    $.ajax({
                                        url: reloadAssociationUrl,
                                        cache: false,
                                        success: function (data) {
                                            $('#AssociationTable').html(data);
                                            $('.ux-dialog').dialog('close');
                                        }
                                    });
                                    return false;
                                }
                                if ($('#modalValidations').html().indexOf("none") >= 0) {
                                    $.ajax({
                                        url: reloadOwnershipUrl,
                                        cache: false,
                                        success: function (data) {
                                            $('#ownershipInformation').html(data);
                                        }
                                    });
                                }
                            }
                            return false;
                        },
                        error: function () {

                        }
                    });
                    return false;
                });
            },
            changeRequestTransactions: function (url, reloadOwnershipUrl) {
                $('#editK1Transactions').one('submit', function (e) {
                    $(this).find('.btn-saveOwnershipTransactions').attr('disabled', 'disabled');
                });

                $('.ux-dialog form#editK1Transactions').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        data: $('.ux-dialog form#editK1Transactions').serialize(),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                if ($('#modalValidations').html().indexOf("none") >= 0) {
                                    $.ajax({
                                        url: reloadOwnershipUrl,
                                        cache: false,
                                        success: function (data) {
                                            $('#ownershipInformation').html(data);
                                        }
                                    });
                                }
                                return false;
                            }
                        },
                        error: function () {
                        }
                    });
                    return false;
                });
            },
            changeRequestFileUpload: function (url, reloadOwnershipUrl) {
                $('#uploadChangeRequestFile').one('submit', function (e) {
                    $(this).find('.btn-saveFileUpload').attr('disabled', 'disabled');
                });

                $('.ux-dialog form#uploadChangeRequestFile').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: new FormData($('.ux-dialog form#uploadChangeRequestFile')[0]),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                if ($('#modalValidations').html().indexOf("none") < 0) {
                                    $("#file-upload-error").toggle(true);
                                }
                                return false;
                            }
                        },
                        error: function () {
                            $.ajax({
                                url: reloadOwnershipUrl,
                                cache: false,
                                success: function (data) {
                                    $(".ui-dialog .ui-dialog-content").html(data);
                                    $("#file-upload-error").toggle(true);
                                },
                                error: function () {
                                    location.reload();
                                }
                            });
                        }
                    });
                    return false;
                });
            },
            generalChangeRequestFileUpload: function (url) {
                $('#uploadChangeRequestFile').one('submit', function (e) {
                    $(this).find('.btn-saveFileUpload').attr('disabled', 'disabled');
                });

                function generalChangeRequestUploadSubmit() {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        contentType: false,
                        processData: false,
                        data: new FormData($('.ux-dialog form#uploadChangeRequestFile')[0]),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                if ($('#modalValidations').html().indexOf("none") < 0) {

                                    $("#file-upload-error").toggle(true);
                                }
                                return false;
                            }
                        },
                        error: function () {
                            $.ajax({
                                url: url,
                                cache: false,
                                success: function (data) {
                                    $(".ui-dialog .ui-dialog-content").html(data);
                                    $("#file-upload-error").toggle(true);
                                },
                                error: function () {
                                    location.reload();
                                }
                            });
                        }
                    });
                    return false;
                }

                common.ui.init.ajaxRecaptcha('.ux-dialog form#uploadChangeRequestFile', generalChangeRequestUploadSubmit);
            },
            unsubscribe: function (unsubscribeUrl) {
                function unsubscribeFormSubmit() {
                    var data = $('form#unsubscribeForm').serialize();
                    if (_mlp.recaptchaEnabled) {
                        data += '&g-recaptcha-response=' + grecaptcha.getResponse();
                    }
                    $.ajax({
                        type: "POST",
                        url: unsubscribeUrl,
                        data: data,
                        cache: false,
                        success: function (result) {
                            common.ui.init.resetRecaptcha();
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $("#UnsubscribeAllRow").html(result);
                            }
                            return false;
                        },
                        error: function () {
                            common.ui.init.resetRecaptcha();
                            location.reload();
                        }
                    });
                    return false;
                }

                common.ui.init.ajaxLoginRecaptcha('form#unsubscribeForm', unsubscribeFormSubmit);
            },
            submitAssociationRequest: function (url, reloadAssociationUrl) {
                $('.ux-dialog form#associationAccessRequest').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        data: $('.ux-dialog form#associationAccessRequest').serialize(),
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                $.ajax({
                                    url: reloadAssociationUrl,
                                    cache: false,
                                    success: function (data) {
                                        $('#AssociationTable').html(data);
                                    }
                                });

                                $('.ux-dialog').dialog('close');
                            }
                            return false;
                        },
                        error: function () {

                        }
                    });
                    return false;
                });
            },
            forgotPasswordForm: function (url) {
                function forgotPasswordFormSubmit() {
                    var data = $('form#forgotPassword').serialize();
                    if (_mlp.recaptchaEnabled) {
                        data += '&g-recaptcha-response=' + grecaptcha.getResponse();
                    }
                    $.ajax({
                           type: "POST",
                            url: url,
                            data: data,
                            cache: false,
                            success: function (result) {
                                common.ui.init.resetRecaptcha();
                                if (result.success) {
                                    location.reload();
                                }
                                else {
                                    $(".ui-dialog .ui-dialog-content").html(result);
                                }
                                return false;
                            },
                            error: function () {
                                common.ui.init.resetRecaptcha();
                                location.reload();
                            }
                        });
                        return false;
                    }

                common.ui.init.ajaxLoginRecaptcha('form#forgotPassword', forgotPasswordFormSubmit);
            },
            verifyPassword: function (url) {
                function changeEmailVerifyPassword() {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        data: $('form#changeEmail-verifyPassword').serialize(),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (result) {
                                $(".ui-dialog .ui-dialog-content").html(result);
                            } else {
                                location.reload();
                            }
                        },
                        error: function () {
                        }

                    });
                    return false;
                };

                common.ui.init.ajaxRecaptcha('.ux-dialog form#changeEmail-verifyPassword', changeEmailVerifyPassword);
            },
            confirmNewEmail: function (url) {
                $("#changeEmail-confirmNewEmail").submit(function () {
                    $.ajax({
                        type: "POST",
                        url: url,
                        cache: false,
                        data: $('form#changeEmail-confirmNewEmail').serialize(),
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (result) {
                                $(".ui-dialog .ui-dialog-content").html(result);
                            } else {
                                location.reload();
                            }
                        },
                        error: function () {
                        }

                    });
                    return false;
                });
            },
            editK1AssociationOptions: function (editOptionsUrl, reloadAssociationUrl) {
                $('.ux-dialog form#editK1AccessTypes').submit(function () {
                    $.ajax({
                        type: "POST",
                        url: editOptionsUrl,
                        data: $('.ux-dialog form#editK1AccessTypes').serialize(),
                        cache: false,
                        beforeSend: function () {
                            common.ui.helper.showDialogSubmitAnimation();
                        },
                        success: function (result) {
                            if (!result) {
                                location.reload();
                            }
                            else {
                                $(".ui-dialog .ui-dialog-content").html(result);
                                if ($('#modalValidations').html().indexOf("none") >= 0) {
                                    if ($('.content-confirm-paperless').length === 0) {
                                        $('.ux-dialog').dialog('close');
                                    }

                                    $.ajax({
                                        url: reloadAssociationUrl,
                                        cache: false,
                                        success: function (data) {
                                            $('#AssociationTable').html(data);
                                        }
                                    });
                                }
                            }
                            return false;
                        },
                        error: function () {
                            $(".btn-primary").removeClass("disabled-button");
                        }
                    });

                    return false;
                });
            }
        }
    }
};
var timeoutConst = {
    msInAMin: 60000,
    timeoutBuffer: 2000,
    timeoutMS: '',
    timeoutWarningMS: '',
    counter: '',
    title: document.title,
    modalActive: false,
    alertHandle: '',
    refreshHandle: '',
    timer: ''
}

var timeout = {
    init: function () {
        timeoutConst.timeoutMS = timeout.getTimeoutMS(tpsTimeoutConst.timeoutMins);
        timeoutConst.timeoutWarningMS = timeout.getTimeoutWarningMS(tpsTimeoutConst.timeoutWarningMins);
        timeoutConst.counter = timeoutConst.timeoutWarningMS;

        $("#auth-timeout-counter").html(timeout.msToTime(timeoutConst.counter));
        $("#extend-session-btn").on("click", timeout.extendSession)

        timeout.setupAlert();
    },
    setupAlert: function () {
        clearTimeout(timeoutConst.alertHandle);

        if (timeoutConst.timeoutMS && timeoutConst.timeoutWarningMS) {
            timeoutConst.alertHandle = setTimeout(timeout.showTimeoutWarning, timeoutConst.timeoutMS - timeoutConst.timeoutWarningMS - timeoutConst.timeoutBuffer)
        }
    },
    showTimeoutWarning: function () {
        if ($(".ui-widget-overlay").is(':visible')) {
            $(".ui-widget-overlay").fadeOut();
            timeoutConst.modalActive = true
        }

        $("#auth-timeout-overlay").css("display", "flex").hide().fadeIn();
        $('#ux-container').css('filter', 'blur(3px)');
        $('#ux-app-container').css('filter', 'blur(3px)');
        $('.ui-widget').css('filter', 'blur(3px)');

        timeoutConst.timer = setInterval(timeout.setupCountdown, 1000);
    },
    setupCountdown: function () {
        if (timeoutConst.counter == 0) {
            timeout.showTimedOutAlert();
            clearInterval(timeoutConst.timer);
        } else {
            var timeLeft = timeout.msToTime(timeoutConst.counter);
            $(document).prop('title', timeLeft + " - Session Ending");
            $("#auth-timeout-counter").html(timeLeft);
            timeoutConst.counter -= 1000;
        }
    },
    showTimedOutAlert: function () {
        $(document).prop('title', "Session Ended");
        $('#auth-timeout-warning').fadeOut();
        $('#auth-timeout-timed-out').fadeIn();
    },
    extendSession: function () {
        clearInterval(timeoutConst.timer);
        clearTimeout(timeoutConst.alertHandle);

        $(document).prop('title', timeoutConst.title);
        $("#auth-timeout-overlay").fadeOut();
        $('#ux-container').css('filter', '');
        $('#ux-app-container').css('filter', '');
        $('.ui-widget').css('filter', '');

        if (timeoutConst.modalActive) {
            $(".ui-widget-overlay").fadeIn();
            timeoutConst.modalActive = false;
        }

        timeoutConst.refreshHandle = setTimeout(timeout.refreshTimeoutPartial, 1000);
    },
    refreshTimeoutPartial: function () {
        $('#ux-app-timeout').load(tpsTimeoutConst.timeoutRefreshURL);
        clearTimeout(timeoutConst.refreshHandle);
    },
    extendSessionFromAjax: function () {
        clearInterval(timeoutConst.timer);
        timeout.setupAlert();
    },
    msToTime: function (duration) {
        var seconds = parseInt((duration / 1000) % 60);
        var minutes = parseInt((duration / (1000 * 60)) % 60);

        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;

        return minutes + ":" + seconds;

    },
    redirectToLogin: function () {
        location.reload();
    },
    getTimeoutMS: function (timeoutMins) {
        var timeout;

        if (!timeoutMins) {
            timeout = 20;
        } else {
            timeout = timeoutMins;
        }

        return timeout * timeoutConst.msInAMin;
    },
    getTimeoutWarningMS: function (timeoutWarningMins) {
        var timeoutWarning;

        if (!timeoutWarningMins) {
            timeoutWarning = 18;
        } else {
            timeoutWarning = timeoutWarningMins;
        }

        return timeoutWarning * timeoutConst.msInAMin;
    }
}
var _d = {
    base: {},
    view: {},
    c: {}
};
var mlp = {
    vars: {
        "dom": "",
        "experience": {
            api: "/scripts/views/client/data/customize.json"
        }
    },
    helpers: {
        firstTimeExperience: function (type) {

            var trackEle;
            var isPremium = false;

            if (type === "add") {
                trackEle = $('#newexperienceaddbuttonalign');
            }
            else if (type === "actions") {
                trackEle = $('.article-content-grid thead .helper-actions');

                if (trackEle.length === 0) {
                    isPremium = true;
                    trackEle = $('#clientPremiumAssociationTable .helper-actions');
                }
            }

            $('body').append($.templates("#helperFirstTimeExperience").render("", { type: type }));

            adjustContext(type, isPremium);

            function adjustContext(obj, isPremium) {
                var trackEleOffset = trackEle.offset();
                var trackEleOffsetTop = trackEleOffset.top;
                var trackEleOffsetLeft = trackEleOffset.left;
                if (obj === "actions") {

                    if (!isPremium) {
                        trackEleOffsetTop += 34;
                        trackEleOffsetLeft += 10;
                    }
                    else {
                        trackEleOffsetTop += 38;
                        trackEleOffsetLeft += 5;
                    }
                }
                $('.context-content').css({ "left": trackEleOffsetLeft, "top": trackEleOffsetTop });
            }

            $(window).resize(function () {
                adjustContext(type, isPremium);
            });
            $('body').on('click', '.ux-experience', function () {
                $('.ux-experience').remove();
            });
        }
    },
    setup: {
        experience: function (type, page, url, confirmAuthenticationUrl) {
            return $.ajax({
                url: url,
                cache: true,
                success: function (d) {
                    var dBase = d.base;
                    var dView;
                    var dType;
                    $.each(d.view, function (i, e) {
                        if (e.setup.type === type) {
                            dView = e;
                            dType = e.setup.type;
                        }
                    });
                    mlp.ui.build.experience(dBase, dView, dType, page, confirmAuthenticationUrl);

                    if (dType === "authentication") {
                        common.auth.browserFingerprint();
                    }
                }
            });
        },
        customize: function () {
            $.ajax({
                url: mlp.vars.view.api,
                cache: false,
                success: function (d) {
                    _d.c = d;
                    mlp.build.customize();
                }
            });
        }
    },
    ui: {
        build: {
            experience: function (dataBase, dataView, dType, page, confirmAuthenticationUrl) {
                ////First build page
                $("#ux-app-container").append($.templates("#layoutTemplate").render(dataView.setup));
                ////Second build shared
                $("#ux-logo").append($.templates("#imageTemplate").render(dataBase.logo));
                $("#ux-app-footer").find('p').html(dataBase.disclaimer);
                ////build articles
                var currTheme = "";
                //Generates Layout Theme
                $.each(dataView.theme, function (i,t) {
                    currTheme += $.templates("#styleTemplate").render(t, { ele: t.ele, type: "article" });
                    if (t.bg.altDescription) {
                        var hiddenAlt = document.createElement("img");
                        hiddenAlt.setAttribute("alt", t.bg.altDescription);
                        hiddenAlt.setAttribute("hidden", true);
                        $(t.ele).append(hiddenAlt);
                    }
                });
                //Generates Articles Theme
                $.each(dataView.articles, function (i, a) {
                    var location = $(".column-" + a.setup.location.toLowerCase());
                    var cssClass = "article-" + i;
                    if (a.setup.page === page) {
                        if (a.setup.type === "authentication") {
                            cssClass = "authentication-client";
                        } else if (a.setup.type === "confirm") {
                            cssClass = "authentication-confirm";
                        }
                        $(location).append(
                            $.templates("#articleTemplate").render(a, { cssClass: cssClass, clientName: dataBase.clientName, clientUrl: dataBase.url })
                        );
                        currTheme += $.templates("#styleTemplate").render(a.theme, { ele: "." + cssClass, type: a.setup.type });
                        if (a.theme.bg.altDescription) {
                            var hiddenAlt = document.createElement("img");
                            hiddenAlt.setAttribute("alt", a.theme.bg.altDescription);
                            hiddenAlt.setAttribute("hidden", true);
                            $("." + cssClass).append(hiddenAlt);
                        }
                    }
                });

                if (dType === "authentication") {
                    common.auth.validation(confirmAuthenticationUrl);
                    common.auth.interactionClient();
                }
                if (dType === "main") {
                    $("#ux-user-container").append($.templates("#commonUserTemplate").render());
                }
                //Add Additional Pages Below

                $("#ux-theme").append(currTheme);

                mlp.ui.init.experience();
            },
            customize: function () {
                $("#ux-logo").append($.templates("#imageTemplate").render(_d.c.base.logo));
                $("#ux-app-footer").find('p').html(_d.c.base.disclaimer);
                $(".ux-section").append($.templates("#customizeTemplate").render(_d.c));
                $(mlp.init());
            }
        },
        init: {
            experience: function () {
                $(function () {
                    $(".ux-tabs.tabs-distributions").tabs();
                });

                $(document).on("click", "td.helper-actions", function () {
                    mlp.helpers.firstTimeExperience('actions');
                });

                // Need to launch Context Help Actions when K1 Available

                //Common UI Elements needs to be triggered
                common.ui.init.experience();
            }
        }
    }
};

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};
